export enum EntityType {
  Article = 'article',
  CaseStudy = 'casestudy',
  Company = 'company',
  JobAd = 'jobad',
  MarketShowcase = 'marketshowcase',
  Project = 'project',
  ProjectOutline = 'projectoutline',
  ProjectPayment = 'projectpayment',
  ProjectPitch = 'projectpitch',
  ProjectShowcase = 'projectshowcase',
  User = 'user',
}

export enum EnumUserInvitationStatus {
  Pending = 'pending',
  Accepted = 'accepted',
  Revoked = 'revoked',
}

export const mapUserInvitationStatus = new Map([
  [EnumUserInvitationStatus.Pending, 'enums.userInvitationStatus.pending'],
  [EnumUserInvitationStatus.Accepted, 'enums.userInvitationStatus.accepted'],
  [EnumUserInvitationStatus.Revoked, 'enums.userInvitationStatus.revoked'],
]);

export enum EnumArticleType {
  Analysis = 'analysis',
  Blog = 'blog',
  Ebook = 'ebook',
  Editorial = 'editorial',
  Guide = 'guide',
  Infographic = 'infographic',
  Interview = 'interview',
  News = 'news',
  Presentation = 'presentation',
  PressRelease = 'press_release',
  Research = 'research',
  Showcase = 'showcase',
  Tutorial = 'tutorial',
}

export enum EnumClaimCompany {
  ApprovedPrivate = 'approved_private',
  ApprovedPublic = 'approved_public',
  Bar = 'bar',
  Baz = 'baz',
  Buyer = 'buyer',
  Foo = 'foo',
  Foobar = 'foobar',
  Seller = 'seller',
  SellerProduct = 'seller_product',
  SellerService = 'seller_service',
}

export enum EnumClaimCompanyUser {
  Bar = 'bar',
  Baz = 'baz',
  CompanyAdmin = 'company_admin',
  EmailVerified = 'email_verified',
  Foo = 'foo',
  Foobar = 'foobar',
  PhoneVerified = 'phone_verified',
}

export enum EnumClaimUser {
  Bar = 'bar',
  EmailVerified = 'email_verified',
  Foo = 'foo',
  Foobar = 'foobar',
  IsSuperuser = 'is_superuser',
  LinkedinVerified = 'linkedin_verified',
  PhoneVerified = 'phone_verified',
  UserVerified = 'user_verified',
}

export enum EnumCompanyLocationType {
  BranchOffice = 'branch_office',
  Headquarters = 'headquarters',
  RegionalHeadquarters = 'regional_headquarters',
  Subsidiary = 'subsidiary',
}

export enum EnumCompanySize {
  Bt_2_10 = 'bt_2_10',
  Bt_11_50 = 'bt_11_50',
  Bt_51_200 = 'bt_51_200',
  Bt_201_500 = 'bt_201_500',
  Bt_501_1000 = 'bt_501_1000',
  Bt_1001_5000 = 'bt_1001_5000',
  Bt_5001_10000 = 'bt_5001_10000',
  Eq_1 = 'eq_1',
  Gte_10001 = 'gte_10001',
}

export const mapCompanySize = new Map([
  [EnumCompanySize.Eq_1, '1 employee'],
  [EnumCompanySize.Bt_2_10, '2-10 employees'],
  [EnumCompanySize.Bt_11_50, '11-50 employees'],
  [EnumCompanySize.Bt_51_200, '51-200 employees'],
  [EnumCompanySize.Bt_201_500, '201-500 employees'],
  [EnumCompanySize.Bt_501_1000, '501-1000 employees'],
  [EnumCompanySize.Bt_1001_5000, '1001-5000 employees'],
  [EnumCompanySize.Bt_5001_10000, '5001-10000 employees'],
  [EnumCompanySize.Gte_10001, '10001+ employees'],
]);

export enum CompanyApprovalStatus {
  Approved = 'approved',
  Rejected = 'rejected',
  Pending = 'pending',
  Unconfirmed = 'unconfirmed',
}

export const mapCompanyApprovalStatus = new Map([
  [CompanyApprovalStatus.Approved, 'enums.companyApprovalStatus.approved'],
  [CompanyApprovalStatus.Rejected, 'enums.companyApprovalStatus.rejected'],
  [CompanyApprovalStatus.Pending, 'enums.companyApprovalStatus.pending'],
  [CompanyApprovalStatus.Unconfirmed, 'enums.companyApprovalStatus.unconfirmed'],
]);

export enum EnumPitchViabilityErrors {
  CaseStudyMissing = 'case_study_missing',
  CaseStudyReviewMissing = 'case_study_review_missing',
  ProfileIncomplete = 'profile_incomplete',
  PitchExists = 'pitch_exists',
}

export enum EnumCountry {
  Ab = 'ab',
  Ad = 'ad',
  Ae = 'ae',
  Af = 'af',
  Ag = 'ag',
  Ai = 'ai',
  Al = 'al',
  Am = 'am',
  Ao = 'ao',
  Aq = 'aq',
  Ar = 'ar',
  As = 'as',
  At = 'at',
  Au = 'au',
  Aw = 'aw',
  Ax = 'ax',
  Az = 'az',
  Ba = 'ba',
  Bb = 'bb',
  Bd = 'bd',
  Be = 'be',
  Bf = 'bf',
  Bg = 'bg',
  Bh = 'bh',
  Bi = 'bi',
  Bj = 'bj',
  Bl = 'bl',
  Bm = 'bm',
  Bn = 'bn',
  Bo = 'bo',
  Bq = 'bq',
  Br = 'br',
  Bs = 'bs',
  Bt = 'bt',
  Bv = 'bv',
  Bw = 'bw',
  By = 'by',
  Bz = 'bz',
  Ca = 'ca',
  Cc = 'cc',
  Cd = 'cd',
  Cf = 'cf',
  Cg = 'cg',
  Ch = 'ch',
  Ci = 'ci',
  Ck = 'ck',
  Cl = 'cl',
  Cm = 'cm',
  Cn = 'cn',
  Co = 'co',
  Cr = 'cr',
  Cu = 'cu',
  Cv = 'cv',
  Cw = 'cw',
  Cx = 'cx',
  Cy = 'cy',
  Cz = 'cz',
  De = 'de',
  Dj = 'dj',
  Dk = 'dk',
  Dm = 'dm',
  Do = 'do',
  Dz = 'dz',
  Ec = 'ec',
  Ee = 'ee',
  Eg = 'eg',
  Eh = 'eh',
  Er = 'er',
  Es = 'es',
  Et = 'et',
  Fi = 'fi',
  Fj = 'fj',
  Fk = 'fk',
  Fm = 'fm',
  Fo = 'fo',
  Fr = 'fr',
  Ga = 'ga',
  Gb = 'gb',
  Gd = 'gd',
  Ge = 'ge',
  Gf = 'gf',
  Gg = 'gg',
  Gh = 'gh',
  Gi = 'gi',
  Gl = 'gl',
  Gm = 'gm',
  Gn = 'gn',
  Gp = 'gp',
  Gq = 'gq',
  Gr = 'gr',
  Gs = 'gs',
  Gt = 'gt',
  Gu = 'gu',
  Gw = 'gw',
  Gy = 'gy',
  Hk = 'hk',
  Hm = 'hm',
  Hn = 'hn',
  Hr = 'hr',
  Ht = 'ht',
  Hu = 'hu',
  Id = 'id',
  Ie = 'ie',
  Il = 'il',
  Im = 'im',
  In = 'in',
  Io = 'io',
  Iq = 'iq',
  Ir = 'ir',
  Is = 'is',
  It = 'it',
  Je = 'je',
  Jm = 'jm',
  Jo = 'jo',
  Jp = 'jp',
  Ke = 'ke',
  Kg = 'kg',
  Kh = 'kh',
  Ki = 'ki',
  Km = 'km',
  Kn = 'kn',
  Kp = 'kp',
  Kr = 'kr',
  Kw = 'kw',
  Ky = 'ky',
  Kz = 'kz',
  La = 'la',
  Lb = 'lb',
  Lc = 'lc',
  Li = 'li',
  Lk = 'lk',
  Lr = 'lr',
  Ls = 'ls',
  Lt = 'lt',
  Lu = 'lu',
  Lv = 'lv',
  Ly = 'ly',
  Ma = 'ma',
  Mc = 'mc',
  Md = 'md',
  Me = 'me',
  Mf = 'mf',
  Mg = 'mg',
  Mh = 'mh',
  Mk = 'mk',
  Ml = 'ml',
  Mm = 'mm',
  Mn = 'mn',
  Mo = 'mo',
  Mp = 'mp',
  Mq = 'mq',
  Mr = 'mr',
  Ms = 'ms',
  Mt = 'mt',
  Mu = 'mu',
  Mv = 'mv',
  Mw = 'mw',
  Mx = 'mx',
  My = 'my',
  Mz = 'mz',
  Na = 'na',
  Nc = 'nc',
  Ne = 'ne',
  Nf = 'nf',
  Ng = 'ng',
  Ni = 'ni',
  Nl = 'nl',
  No = 'no',
  Np = 'np',
  Nr = 'nr',
  Nu = 'nu',
  Nz = 'nz',
  Om = 'om',
  Pa = 'pa',
  Pe = 'pe',
  Pf = 'pf',
  Pg = 'pg',
  Ph = 'ph',
  Pk = 'pk',
  Pl = 'pl',
  Pm = 'pm',
  Pn = 'pn',
  Pr = 'pr',
  Ps = 'ps',
  Pt = 'pt',
  Pw = 'pw',
  Py = 'py',
  Qa = 'qa',
  Re = 're',
  Ro = 'ro',
  Rs = 'rs',
  Ru = 'ru',
  Rw = 'rw',
  Sa = 'sa',
  Sb = 'sb',
  Sc = 'sc',
  Sd = 'sd',
  Se = 'se',
  Sg = 'sg',
  Sh = 'sh',
  Si = 'si',
  Sj = 'sj',
  Sk = 'sk',
  Sl = 'sl',
  Sm = 'sm',
  Sn = 'sn',
  So = 'so',
  Sr = 'sr',
  Ss = 'ss',
  St = 'st',
  Sv = 'sv',
  Sx = 'sx',
  Sy = 'sy',
  Sz = 'sz',
  Tc = 'tc',
  Td = 'td',
  Tf = 'tf',
  Tg = 'tg',
  Th = 'th',
  Tj = 'tj',
  Tk = 'tk',
  Tl = 'tl',
  Tm = 'tm',
  Tn = 'tn',
  To = 'to',
  Tr = 'tr',
  Tt = 'tt',
  Tv = 'tv',
  Tw = 'tw',
  Tz = 'tz',
  Ua = 'ua',
  Ug = 'ug',
  Um = 'um',
  Us = 'us',
  Uy = 'uy',
  Uz = 'uz',
  Va = 'va',
  Vc = 'vc',
  Ve = 've',
  Vg = 'vg',
  Vi = 'vi',
  Vn = 'vn',
  Vu = 'vu',
  Wf = 'wf',
  Ws = 'ws',
  Xk = 'xk',
  Ye = 'ye',
  Yt = 'yt',
  Za = 'za',
  Zm = 'zm',
  Zw = 'zw',
}

export const mapCountry = new Map([
  [EnumCountry.Ab, 'country.ab'],
  [EnumCountry.Ad, 'country.ad'],
  [EnumCountry.Ae, 'country.ae'],
  [EnumCountry.Af, 'country.af'],
  [EnumCountry.Ag, 'country.ag'],
  [EnumCountry.Ai, 'country.ai'],
  [EnumCountry.Al, 'country.al'],
  [EnumCountry.Am, 'country.am'],
  [EnumCountry.Ao, 'country.ao'],
  [EnumCountry.Aq, 'country.aq'],
  [EnumCountry.Ar, 'country.ar'],
  [EnumCountry.As, 'country.as'],
  [EnumCountry.At, 'country.at'],
  [EnumCountry.Au, 'country.au'],
  [EnumCountry.Aw, 'country.aw'],
  [EnumCountry.Ax, 'country.ax'],
  [EnumCountry.Az, 'country.az'],
  [EnumCountry.Ba, 'country.ba'],
  [EnumCountry.Bb, 'country.bb'],
  [EnumCountry.Bd, 'country.bd'],
  [EnumCountry.Be, 'country.be'],
  [EnumCountry.Bf, 'country.bf'],
  [EnumCountry.Bg, 'country.bg'],
  [EnumCountry.Bh, 'country.bh'],
  [EnumCountry.Bi, 'country.bi'],
  [EnumCountry.Bj, 'country.bj'],
  [EnumCountry.Bl, 'country.bl'],
  [EnumCountry.Bm, 'country.bm'],
  [EnumCountry.Bn, 'country.bn'],
  [EnumCountry.Bo, 'country.bo'],
  [EnumCountry.Bq, 'country.bq'],
  [EnumCountry.Br, 'country.br'],
  [EnumCountry.Bs, 'country.bs'],
  [EnumCountry.Bt, 'country.bt'],
  [EnumCountry.Bv, 'country.bv'],
  [EnumCountry.Bw, 'country.bw'],
  [EnumCountry.By, 'country.by'],
  [EnumCountry.Bz, 'country.bz'],
  [EnumCountry.Ca, 'country.ca'],
  [EnumCountry.Cc, 'country.cc'],
  [EnumCountry.Cd, 'country.cd'],
  [EnumCountry.Cf, 'country.cf'],
  [EnumCountry.Cg, 'country.cg'],
  [EnumCountry.Ch, 'country.ch'],
  [EnumCountry.Ci, 'country.ci'],
  [EnumCountry.Ck, 'country.ck'],
  [EnumCountry.Cl, 'country.cl'],
  [EnumCountry.Cm, 'country.cm'],
  [EnumCountry.Cn, 'country.cn'],
  [EnumCountry.Co, 'country.co'],
  [EnumCountry.Cr, 'country.cr'],
  [EnumCountry.Cu, 'country.cu'],
  [EnumCountry.Cv, 'country.cv'],
  [EnumCountry.Cw, 'country.cw'],
  [EnumCountry.Cx, 'country.cx'],
  [EnumCountry.Cy, 'country.cy'],
  [EnumCountry.Cz, 'country.cz'],
  [EnumCountry.De, 'country.de'],
  [EnumCountry.Dj, 'country.dj'],
  [EnumCountry.Dk, 'country.dk'],
  [EnumCountry.Dm, 'country.dm'],
  [EnumCountry.Do, 'country.do'],
  [EnumCountry.Dz, 'country.dz'],
  [EnumCountry.Ec, 'country.ec'],
  [EnumCountry.Ee, 'country.ee'],
  [EnumCountry.Eg, 'country.eg'],
  [EnumCountry.Eh, 'country.eh'],
  [EnumCountry.Er, 'country.er'],
  [EnumCountry.Es, 'country.es'],
  [EnumCountry.Et, 'country.et'],
  [EnumCountry.Fi, 'country.fi'],
  [EnumCountry.Fj, 'country.fj'],
  [EnumCountry.Fk, 'country.fk'],
  [EnumCountry.Fm, 'country.fm'],
  [EnumCountry.Fo, 'country.fo'],
  [EnumCountry.Fr, 'country.fr'],
  [EnumCountry.Ga, 'country.ga'],
  [EnumCountry.Gb, 'country.gb'],
  [EnumCountry.Gd, 'country.gd'],
  [EnumCountry.Ge, 'country.ge'],
  [EnumCountry.Gf, 'country.gf'],
  [EnumCountry.Gg, 'country.gg'],
  [EnumCountry.Gh, 'country.gh'],
  [EnumCountry.Gi, 'country.gi'],
  [EnumCountry.Gl, 'country.gl'],
  [EnumCountry.Gm, 'country.gm'],
  [EnumCountry.Gn, 'country.gn'],
  [EnumCountry.Gp, 'country.gp'],
  [EnumCountry.Gq, 'country.gq'],
  [EnumCountry.Gr, 'country.gr'],
  [EnumCountry.Gs, 'country.gs'],
  [EnumCountry.Gt, 'country.gt'],
  [EnumCountry.Gu, 'country.gu'],
  [EnumCountry.Gw, 'country.gw'],
  [EnumCountry.Gy, 'country.gy'],
  [EnumCountry.Hk, 'country.hk'],
  [EnumCountry.Hm, 'country.hm'],
  [EnumCountry.Hn, 'country.hn'],
  [EnumCountry.Hr, 'country.hr'],
  [EnumCountry.Ht, 'country.ht'],
  [EnumCountry.Hu, 'country.hu'],
  [EnumCountry.Id, 'country.id'],
  [EnumCountry.Ie, 'country.ie'],
  [EnumCountry.Il, 'country.il'],
  [EnumCountry.Im, 'country.im'],
  [EnumCountry.In, 'country.in'],
  [EnumCountry.Io, 'country.io'],
  [EnumCountry.Iq, 'country.iq'],
  [EnumCountry.Ir, 'country.ir'],
  [EnumCountry.Is, 'country.is'],
  [EnumCountry.It, 'country.it'],
  [EnumCountry.Je, 'country.je'],
  [EnumCountry.Jm, 'country.jm'],
  [EnumCountry.Jo, 'country.jo'],
  [EnumCountry.Jp, 'country.jp'],
  [EnumCountry.Ke, 'country.ke'],
  [EnumCountry.Kg, 'country.kg'],
  [EnumCountry.Kh, 'country.kh'],
  [EnumCountry.Ki, 'country.ki'],
  [EnumCountry.Km, 'country.km'],
  [EnumCountry.Kn, 'country.kn'],
  [EnumCountry.Kp, 'country.kp'],
  [EnumCountry.Kr, 'country.kr'],
  [EnumCountry.Kw, 'country.kw'],
  [EnumCountry.Ky, 'country.ky'],
  [EnumCountry.Kz, 'country.kz'],
  [EnumCountry.La, 'country.la'],
  [EnumCountry.Lb, 'country.lb'],
  [EnumCountry.Lc, 'country.lc'],
  [EnumCountry.Li, 'country.li'],
  [EnumCountry.Lk, 'country.lk'],
  [EnumCountry.Lr, 'country.lr'],
  [EnumCountry.Ls, 'country.ls'],
  [EnumCountry.Lt, 'country.lt'],
  [EnumCountry.Lu, 'country.lu'],
  [EnumCountry.Lv, 'country.lv'],
  [EnumCountry.Ly, 'country.ly'],
  [EnumCountry.Ma, 'country.ma'],
  [EnumCountry.Mc, 'country.mc'],
  [EnumCountry.Md, 'country.md'],
  [EnumCountry.Me, 'country.me'],
  [EnumCountry.Mf, 'country.mf'],
  [EnumCountry.Mg, 'country.mg'],
  [EnumCountry.Mh, 'country.mh'],
  [EnumCountry.Mk, 'country.mk'],
  [EnumCountry.Ml, 'country.ml'],
  [EnumCountry.Mm, 'country.mm'],
  [EnumCountry.Mn, 'country.mn'],
  [EnumCountry.Mo, 'country.mo'],
  [EnumCountry.Mp, 'country.mp'],
  [EnumCountry.Mq, 'country.mq'],
  [EnumCountry.Mr, 'country.mr'],
  [EnumCountry.Ms, 'country.ms'],
  [EnumCountry.Mt, 'country.mt'],
  [EnumCountry.Mu, 'country.mu'],
  [EnumCountry.Mv, 'country.mv'],
  [EnumCountry.Mw, 'country.mw'],
  [EnumCountry.Mx, 'country.mx'],
  [EnumCountry.My, 'country.my'],
  [EnumCountry.Mz, 'country.mz'],
  [EnumCountry.Na, 'country.na'],
  [EnumCountry.Nc, 'country.nc'],
  [EnumCountry.Ne, 'country.ne'],
  [EnumCountry.Nf, 'country.nf'],
  [EnumCountry.Ng, 'country.ng'],
  [EnumCountry.Ni, 'country.ni'],
  [EnumCountry.Nl, 'country.nl'],
  [EnumCountry.No, 'country.no'],
  [EnumCountry.Np, 'country.np'],
  [EnumCountry.Nr, 'country.nr'],
  [EnumCountry.Nu, 'country.nu'],
  [EnumCountry.Nz, 'country.nz'],
  [EnumCountry.Om, 'country.om'],
  [EnumCountry.Pa, 'country.pa'],
  [EnumCountry.Pe, 'country.pe'],
  [EnumCountry.Pf, 'country.pf'],
  [EnumCountry.Pg, 'country.pg'],
  [EnumCountry.Ph, 'country.ph'],
  [EnumCountry.Pk, 'country.pk'],
  [EnumCountry.Pl, 'country.pl'],
  [EnumCountry.Pm, 'country.pm'],
  [EnumCountry.Pn, 'country.pn'],
  [EnumCountry.Pr, 'country.pr'],
  [EnumCountry.Ps, 'country.ps'],
  [EnumCountry.Pt, 'country.pt'],
  [EnumCountry.Pw, 'country.pw'],
  [EnumCountry.Py, 'country.py'],
  [EnumCountry.Qa, 'country.qa'],
  [EnumCountry.Re, 'country.re'],
  [EnumCountry.Ro, 'country.ro'],
  [EnumCountry.Rs, 'country.rs'],
  [EnumCountry.Ru, 'country.ru'],
  [EnumCountry.Rw, 'country.rw'],
  [EnumCountry.Sa, 'country.sa'],
  [EnumCountry.Sb, 'country.sb'],
  [EnumCountry.Sc, 'country.sc'],
  [EnumCountry.Sd, 'country.sd'],
  [EnumCountry.Se, 'country.se'],
  [EnumCountry.Sg, 'country.sg'],
  [EnumCountry.Sh, 'country.sh'],
  [EnumCountry.Si, 'country.si'],
  [EnumCountry.Sj, 'country.sj'],
  [EnumCountry.Sk, 'country.sk'],
  [EnumCountry.Sl, 'country.sl'],
  [EnumCountry.Sm, 'country.sm'],
  [EnumCountry.Sn, 'country.sn'],
  [EnumCountry.So, 'country.so'],
  [EnumCountry.Sr, 'country.sr'],
  [EnumCountry.Ss, 'country.ss'],
  [EnumCountry.St, 'country.st'],
  [EnumCountry.Sv, 'country.sv'],
  [EnumCountry.Sx, 'country.sx'],
  [EnumCountry.Sy, 'country.sy'],
  [EnumCountry.Sz, 'country.sz'],
  [EnumCountry.Tc, 'country.tc'],
  [EnumCountry.Td, 'country.td'],
  [EnumCountry.Tf, 'country.tf'],
  [EnumCountry.Tg, 'country.tg'],
  [EnumCountry.Th, 'country.th'],
  [EnumCountry.Tj, 'country.tj'],
  [EnumCountry.Tk, 'country.tk'],
  [EnumCountry.Tl, 'country.tl'],
  [EnumCountry.Tm, 'country.tm'],
  [EnumCountry.Tn, 'country.tn'],
  [EnumCountry.To, 'country.to'],
  [EnumCountry.Tr, 'country.tr'],
  [EnumCountry.Tt, 'country.tt'],
  [EnumCountry.Tv, 'country.tv'],
  [EnumCountry.Tw, 'country.tw'],
  [EnumCountry.Tz, 'country.tz'],
  [EnumCountry.Ua, 'country.ua'],
  [EnumCountry.Ug, 'country.ug'],
  [EnumCountry.Um, 'country.um'],
  [EnumCountry.Us, 'country.us'],
  [EnumCountry.Uy, 'country.uy'],
  [EnumCountry.Uz, 'country.uz'],
  [EnumCountry.Va, 'country.va'],
  [EnumCountry.Vc, 'country.vc'],
  [EnumCountry.Ve, 'country.ve'],
  [EnumCountry.Vg, 'country.vg'],
  [EnumCountry.Vi, 'country.vi'],
  [EnumCountry.Vn, 'country.vn'],
  [EnumCountry.Vu, 'country.vu'],
  [EnumCountry.Wf, 'country.wf'],
  [EnumCountry.Ws, 'country.ws'],
  [EnumCountry.Xk, 'country.xk'],
  [EnumCountry.Ye, 'country.ye'],
  [EnumCountry.Yt, 'country.yt'],
  [EnumCountry.Za, 'country.za'],
  [EnumCountry.Zm, 'country.zm'],
  [EnumCountry.Zw, 'country.zw'],
]);

export enum EnumCurrency {
  Eur = 'eur',
  Btc = 'btc',
  Eth = 'eth',
  Hrk = 'hrk',
  Inr = 'inr',
  Usd = 'usd',
}

export const mapCurrency = new Map([
  [EnumCurrency.Eur, 'EUR'],
  [EnumCurrency.Usd, 'USD'],
]);

export const mapCurrencySimbol = new Map([
  [EnumCurrency.Eur, '€'],
  [EnumCurrency.Usd, '$'],
]);

export enum EnumIndustry {
  Accounting = 'accounting',
  AirlinesAndAviation = 'airlines_and_aviation',
  AlternativeDisputeResolution = 'alternative_dispute_resolution',
  AlternativeMedicine = 'alternative_medicine',
  Animation = 'animation',
  ApparelAndFashion = 'apparel_and_fashion',
  ArchitectureAndPlanning = 'architecture_and_planning',
  ArtsAndCrafts = 'arts_and_crafts',
  Automotive = 'automotive',
  AviationAndAerospace = 'aviation_and_aerospace',
  Banking = 'banking',
  Biotechnology = 'biotechnology',
  BroadcastMedia = 'broadcast_media',
  BuildingMaterials = 'building_materials',
  BusinessSuppliesAndEquipment = 'business_supplies_and_equipment',
  CapitalMarkets = 'capital_markets',
  Chemicals = 'chemicals',
  CivicAndSocialOrganization = 'civic_and_social_organization',
  CivilEngineering = 'civil_engineering',
  CommercialRealEstate = 'commercial_real_estate',
  ComputerGames = 'computer_games',
  ComputerHardware = 'computer_hardware',
  ComputerNetworking = 'computer_networking',
  ComputerSoftware = 'computer_software',
  ComputerAndNetworkSecurity = 'computer_and_network_security',
  Construction = 'construction',
  ConsumerElectronics = 'consumer_electronics',
  ConsumerGoods = 'consumer_goods',
  ConsumerServices = 'consumer_services',
  Cosmetics = 'cosmetics',
  Dairy = 'dairy',
  DefenseAndSpace = 'defense_and_space',
  Design = 'design',
  EducationManagement = 'education_management',
  Elearning = 'elearning',
  ElectricalOrElectronicManufacturing = 'electrical_or_electronic_manufacturing',
  Energy = 'energy',
  Entertainment = 'entertainment',
  EnvironmentalServices = 'environmental_services',
  EventsServices = 'events_services',
  ExecutiveOffice = 'executive_office',
  FacilitiesServices = 'facilities_services',
  Farming = 'farming',
  FastMovingConsumerGoods = 'fast_moving_consumer_goods',
  FinancialServices = 'financial_services',
  FineArt = 'fine_art',
  Fishery = 'fishery',
  FoodProduction = 'food_production',
  FoodAndBeverages = 'food_and_beverages',
  Fundraising = 'fundraising',
  Furniture = 'furniture',
  GamblingAndCasinos = 'gambling_and_casinos',
  GlassAndCeramicsAndConcrete = 'glass_and_ceramics_and_concrete',
  GovernmentAdministration = 'government_administration',
  GovernmentRelations = 'government_relations',
  GraphicDesign = 'graphic_design',
  HealthAndWellnessAndFitness = 'health_and_wellness_and_fitness',
  HigherEducation = 'higher_education',
  HospitalAndHealthCare = 'hospital_and_health_care',
  Hospitality = 'hospitality',
  HumanResources = 'human_resources',
  ImportAndExport = 'import_and_export',
  IndividualAndFamilyServices = 'individual_and_family_services',
  IndustrialAutomation = 'industrial_automation',
  InformationServices = 'information_services',
  InformationTechnology = 'information_technology',
  Insurance = 'insurance',
  InternationalAffairs = 'international_affairs',
  InternationalTradeAndDevelopment = 'international_trade_and_development',
  Internet = 'internet',
  InvestmentBanking = 'investment_banking',
  InvestmentManagement = 'investment_management',
  Judiciary = 'judiciary',
  LawEnforcement = 'law_enforcement',
  LawPractice = 'law_practice',
  LegalServices = 'legal_services',
  LegislativeOffice = 'legislative_office',
  LeisureAndTravelAndTourism = 'leisure_and_travel_and_tourism',
  Libraries = 'libraries',
  LogisticsAndSupplyChain = 'logistics_and_supply_chain',
  LuxuryGoodsAndJewelry = 'luxury_goods_and_jewelry',
  Machinery = 'machinery',
  ManagementConsulting = 'management_consulting',
  Maritime = 'maritime',
  MarketResearch = 'market_research',
  MarketingAndAdvertising = 'marketing_and_advertising',
  MechanicalOrIndustrialEngineering = 'mechanical_or_industrial_engineering',
  MediaProduction = 'media_production',
  MedicalDevices = 'medical_devices',
  MedicalPractice = 'medical_practice',
  MentalHealthCare = 'mental_health_care',
  Military = 'military',
  MiningAndMetals = 'mining_and_metals',
  MotionPicturesAndFilm = 'motion_pictures_and_film',
  MuseumsAndInstitutions = 'museums_and_institutions',
  Music = 'music',
  Nanotechnology = 'nanotechnology',
  Newspapers = 'newspapers',
  NonprofitOrganizationManagement = 'nonprofit_organization_management',
  OilAndGas = 'oil_and_gas',
  OnlineMedia = 'online_media',
  OutsourcingOrOffshoring = 'outsourcing_or_offshoring',
  PackageOrFreightDelivery = 'package_or_freight_delivery',
  PackagingAndContainers = 'packaging_and_containers',
  PaperAndForestProducts = 'paper_and_forest_products',
  PerformingArts = 'performing_arts',
  Pharmaceuticals = 'pharmaceuticals',
  Philanthropy = 'philanthropy',
  Photography = 'photography',
  Plastics = 'plastics',
  PoliticalOrganization = 'political_organization',
  PrimaryOrSecondaryEducation = 'primary_or_secondary_education',
  Printing = 'printing',
  ProfessionalTrainingAndCoaching = 'professional_training_and_coaching',
  ProgramDevelopment = 'program_development',
  PublicPolicy = 'public_policy',
  PublicRelationsAndCommunications = 'public_relations_and_communications',
  PublicSafety = 'public_safety',
  Publishing = 'publishing',
  RailroadManufacture = 'railroad_manufacture',
  Ranching = 'ranching',
  RealEstate = 'real_estate',
  RecreationalFacilitiesAndServices = 'recreational_facilities_and_services',
  ReligiousInstitutions = 'religious_institutions',
  RenewablesAndEnvironment = 'renewables_and_environment',
  Research = 'research',
  Restaurants = 'restaurants',
  Retail = 'retail',
  SecurityAndInvestigations = 'security_and_investigations',
  Semiconductors = 'semiconductors',
  Shipbuilding = 'shipbuilding',
  SportingGoods = 'sporting_goods',
  Sports = 'sports',
  StaffingAndRecruiting = 'staffing_and_recruiting',
  Supermarkets = 'supermarkets',
  Telecommunications = 'telecommunications',
  Textiles = 'textiles',
  ThinkTanks = 'think_tanks',
  Tobacco = 'tobacco',
  TranslationAndLocalization = 'translation_and_localization',
  TransportationgAndTruckingAndRailroad = 'transportationg_and_trucking_and_railroad',
  Utilities = 'utilities',
  VentureCapitalAndPrivateEquity = 'venture_capital_and_private_equity',
  Veterinary = 'veterinary',
  Warehousing = 'warehousing',
  Wholesale = 'wholesale',
  WineAndSpirits = 'wine_and_spirits',
  Wireless = 'wireless',
  WritingAndEditing = 'writing_and_editing',
}

export const mapIndustry = new Map([
  [EnumIndustry.Accounting, 'industry.accounting'],
  [EnumIndustry.AirlinesAndAviation, 'industry.airlines_and_aviation'],
  [EnumIndustry.AlternativeDisputeResolution, 'industry.alternative_dispute_resolution'],
  [EnumIndustry.AlternativeMedicine, 'industry.alternative_medicine'],
  [EnumIndustry.Animation, 'industry.animation'],
  [EnumIndustry.ApparelAndFashion, 'industry.apparel_and_fashion'],
  [EnumIndustry.ArchitectureAndPlanning, 'industry.architecture_and_planning'],
  [EnumIndustry.ArtsAndCrafts, 'industry.arts_and_crafts'],
  [EnumIndustry.Automotive, 'industry.automotive'],
  [EnumIndustry.AviationAndAerospace, 'industry.aviation_and_aerospace'],
  [EnumIndustry.Banking, 'industry.banking'],
  [EnumIndustry.Biotechnology, 'industry.biotechnology'],
  [EnumIndustry.BroadcastMedia, 'industry.broadcast_media'],
  [EnumIndustry.BuildingMaterials, 'industry.building_materials'],
  [EnumIndustry.BusinessSuppliesAndEquipment, 'industry.business_supplies_and_equipment'],
  [EnumIndustry.CapitalMarkets, 'industry.capital_markets'],
  [EnumIndustry.Chemicals, 'industry.chemicals'],
  [EnumIndustry.CivicAndSocialOrganization, 'industry.civic_and_social_organization'],
  [EnumIndustry.CivilEngineering, 'industry.civil_engineering'],
  [EnumIndustry.CommercialRealEstate, 'industry.commercial_real_estate'],
  [EnumIndustry.ComputerAndNetworkSecurity, 'industry.computer_and_network_security'],
  [EnumIndustry.ComputerGames, 'industry.computer_games'],
  [EnumIndustry.ComputerHardware, 'industry.computer_hardware'],
  [EnumIndustry.ComputerNetworking, 'industry.computer_networking'],
  [EnumIndustry.ComputerSoftware, 'industry.computer_software'],
  [EnumIndustry.Construction, 'industry.construction'],
  [EnumIndustry.ConsumerElectronics, 'industry.consumer_electronics'],
  [EnumIndustry.ConsumerGoods, 'industry.consumer_goods'],
  [EnumIndustry.ConsumerServices, 'industry.consumer_services'],
  [EnumIndustry.Cosmetics, 'industry.cosmetics'],
  [EnumIndustry.Dairy, 'industry.dairy'],
  [EnumIndustry.DefenseAndSpace, 'industry.defense_and_space'],
  [EnumIndustry.Design, 'industry.design'],
  [EnumIndustry.Elearning, 'industry.elearning'],
  [EnumIndustry.EducationManagement, 'industry.education_management'],
  [EnumIndustry.ElectricalOrElectronicManufacturing, 'industry.electrical_or_electronic_manufacturing'],
  [EnumIndustry.Energy, 'industry.energy'],
  [EnumIndustry.Entertainment, 'industry.entertainment'],
  [EnumIndustry.EnvironmentalServices, 'industry.environmental_services'],
  [EnumIndustry.EventsServices, 'industry.events_services'],
  [EnumIndustry.ExecutiveOffice, 'industry.executive_office'],
  [EnumIndustry.FacilitiesServices, 'industry.facilities_services'],
  [EnumIndustry.Farming, 'industry.farming'],
  [EnumIndustry.FastMovingConsumerGoods, 'industry.fast_moving_consumer_goods'],
  [EnumIndustry.FinancialServices, 'industry.financial_services'],
  [EnumIndustry.FineArt, 'industry.fine_art'],
  [EnumIndustry.Fishery, 'industry.fishery'],
  [EnumIndustry.FoodAndBeverages, 'industry.food_and_beverages'],
  [EnumIndustry.FoodProduction, 'industry.food_production'],
  [EnumIndustry.Fundraising, 'industry.fundraising'],
  [EnumIndustry.Furniture, 'industry.furniture'],
  [EnumIndustry.GamblingAndCasinos, 'industry.gambling_and_casinos'],
  [EnumIndustry.GlassAndCeramicsAndConcrete, 'industry.glass_and_ceramics_and_concrete'],
  [EnumIndustry.GovernmentAdministration, 'industry.government_administration'],
  [EnumIndustry.GovernmentRelations, 'industry.government_relations'],
  [EnumIndustry.GraphicDesign, 'industry.graphic_design'],
  [EnumIndustry.HealthAndWellnessAndFitness, 'industry.health_and_wellness_and_fitness'],
  [EnumIndustry.HigherEducation, 'industry.higher_education'],
  [EnumIndustry.HospitalAndHealthCare, 'industry.hospital_and_health_care'],
  [EnumIndustry.Hospitality, 'industry.hospitality'],
  [EnumIndustry.HumanResources, 'industry.human_resources'],
  [EnumIndustry.ImportAndExport, 'industry.import_and_export'],
  [EnumIndustry.IndividualAndFamilyServices, 'industry.individual_and_family_services'],
  [EnumIndustry.IndustrialAutomation, 'industry.industrial_automation'],
  [EnumIndustry.InformationServices, 'industry.information_services'],
  [EnumIndustry.InformationTechnology, 'industry.information_technology'],
  [EnumIndustry.Insurance, 'industry.insurance'],
  [EnumIndustry.InternationalAffairs, 'industry.international_affairs'],
  [EnumIndustry.InternationalTradeAndDevelopment, 'industry.international_trade_and_development'],
  [EnumIndustry.Internet, 'industry.internet'],
  [EnumIndustry.InvestmentBanking, 'industry.investment_banking'],
  [EnumIndustry.InvestmentManagement, 'industry.investment_management'],
  [EnumIndustry.Judiciary, 'industry.judiciary'],
  [EnumIndustry.LawEnforcement, 'industry.law_enforcement'],
  [EnumIndustry.LawPractice, 'industry.law_practice'],
  [EnumIndustry.LegalServices, 'industry.legal_services'],
  [EnumIndustry.LegislativeOffice, 'industry.legislative_office'],
  [EnumIndustry.LeisureAndTravelAndTourism, 'industry.leisure_and_travel_and_tourism'],
  [EnumIndustry.Libraries, 'industry.libraries'],
  [EnumIndustry.LogisticsAndSupplyChain, 'industry.logistics_and_supply_chain'],
  [EnumIndustry.LuxuryGoodsAndJewelry, 'industry.luxury_goods_and_jewelry'],
  [EnumIndustry.Machinery, 'industry.machinery'],
  [EnumIndustry.ManagementConsulting, 'industry.management_consulting'],
  [EnumIndustry.Maritime, 'industry.maritime'],
  [EnumIndustry.MarketResearch, 'industry.market_research'],
  [EnumIndustry.MarketingAndAdvertising, 'industry.marketing_and_advertising'],
  [EnumIndustry.MechanicalOrIndustrialEngineering, 'industry.mechanical_or_industrial_engineering'],
  [EnumIndustry.MediaProduction, 'industry.media_production'],
  [EnumIndustry.MedicalDevices, 'industry.medical_devices'],
  [EnumIndustry.MedicalPractice, 'industry.medical_practice'],
  [EnumIndustry.MentalHealthCare, 'industry.mental_health_care'],
  [EnumIndustry.Military, 'industry.military'],
  [EnumIndustry.MiningAndMetals, 'industry.mining_and_metals'],
  [EnumIndustry.MotionPicturesAndFilm, 'industry.motion_pictures_and_film'],
  [EnumIndustry.MuseumsAndInstitutions, 'industry.museums_and_institutions'],
  [EnumIndustry.Music, 'industry.music'],
  [EnumIndustry.Nanotechnology, 'industry.nanotechnology'],
  [EnumIndustry.Newspapers, 'industry.newspapers'],
  [EnumIndustry.NonprofitOrganizationManagement, 'industry.nonprofit_organization_management'],
  [EnumIndustry.OilAndGas, 'industry.oil_and_gas'],
  [EnumIndustry.OnlineMedia, 'industry.online_media'],
  [EnumIndustry.OutsourcingOrOffshoring, 'industry.outsourcing_or_offshoring'],
  [EnumIndustry.PackageOrFreightDelivery, 'industry.package_or_freight_delivery'],
  [EnumIndustry.PackagingAndContainers, 'industry.packaging_and_containers'],
  [EnumIndustry.PaperAndForestProducts, 'industry.paper_and_forest_products'],
  [EnumIndustry.PerformingArts, 'industry.performing_arts'],
  [EnumIndustry.Pharmaceuticals, 'industry.pharmaceuticals'],
  [EnumIndustry.Philanthropy, 'industry.philanthropy'],
  [EnumIndustry.Photography, 'industry.photography'],
  [EnumIndustry.Plastics, 'industry.plastics'],
  [EnumIndustry.PoliticalOrganization, 'industry.political_organization'],
  [EnumIndustry.PrimaryOrSecondaryEducation, 'industry.primary_or_secondary_education'],
  [EnumIndustry.Printing, 'industry.printing'],
  [EnumIndustry.ProfessionalTrainingAndCoaching, 'industry.professional_training_and_coaching'],
  [EnumIndustry.ProgramDevelopment, 'industry.program_development'],
  [EnumIndustry.PublicPolicy, 'industry.public_policy'],
  [EnumIndustry.PublicRelationsAndCommunications, 'industry.public_relations_and_communications'],
  [EnumIndustry.PublicSafety, 'industry.public_safety'],
  [EnumIndustry.Publishing, 'industry.publishing'],
  [EnumIndustry.RailroadManufacture, 'industry.railroad_manufacture'],
  [EnumIndustry.Ranching, 'industry.ranching'],
  [EnumIndustry.RealEstate, 'industry.real_estate'],
  [EnumIndustry.RecreationalFacilitiesAndServices, 'industry.recreational_facilities_and_services'],
  [EnumIndustry.ReligiousInstitutions, 'industry.religious_institutions'],
  [EnumIndustry.RenewablesAndEnvironment, 'industry.renewables_and_environment'],
  [EnumIndustry.Research, 'industry.research'],
  [EnumIndustry.Restaurants, 'industry.restaurants'],
  [EnumIndustry.Retail, 'industry.retail'],
  [EnumIndustry.SecurityAndInvestigations, 'industry.security_and_investigations'],
  [EnumIndustry.Semiconductors, 'industry.semiconductors'],
  [EnumIndustry.Shipbuilding, 'industry.shipbuilding'],
  [EnumIndustry.SportingGoods, 'industry.sporting_goods'],
  [EnumIndustry.Sports, 'industry.sports'],
  [EnumIndustry.StaffingAndRecruiting, 'industry.staffing_and_recruiting'],
  [EnumIndustry.Supermarkets, 'industry.supermarkets'],
  [EnumIndustry.Telecommunications, 'industry.telecommunications'],
  [EnumIndustry.Textiles, 'industry.textiles'],
  [EnumIndustry.ThinkTanks, 'industry.think_tanks'],
  [EnumIndustry.Tobacco, 'industry.tobacco'],
  [EnumIndustry.TranslationAndLocalization, 'industry.translation_and_localization'],
  [EnumIndustry.TransportationgAndTruckingAndRailroad, 'industry.transportationg_and_trucking_and_railroad'],
  [EnumIndustry.Utilities, 'industry.utilities'],
  [EnumIndustry.VentureCapitalAndPrivateEquity, 'industry.venture_capital_and_private_equity'],
  [EnumIndustry.Veterinary, 'industry.veterinary'],
  [EnumIndustry.Warehousing, 'industry.warehousing'],
  [EnumIndustry.Wholesale, 'industry.wholesale'],
  [EnumIndustry.WineAndSpirits, 'industry.wine_and_spirits'],
  [EnumIndustry.Wireless, 'industry.wireless'],
  [EnumIndustry.WritingAndEditing, 'industry.writing_and_editing'],
]);

export enum EnumLanguage {
  Aa = 'aa',
  Ab = 'ab',
  Ae = 'ae',
  Af = 'af',
  Ak = 'ak',
  Am = 'am',
  An = 'an',
  Ar = 'ar',
  As = 'as',
  Av = 'av',
  Ay = 'ay',
  Az = 'az',
  Ba = 'ba',
  Be = 'be',
  Bg = 'bg',
  Bi = 'bi',
  Bm = 'bm',
  Bn = 'bn',
  Bo = 'bo',
  Br = 'br',
  Bs = 'bs',
  Ca = 'ca',
  Ce = 'ce',
  Ch = 'ch',
  Cnr = 'cnr',
  Co = 'co',
  Cr = 'cr',
  Cs = 'cs',
  Cu = 'cu',
  Cv = 'cv',
  Cy = 'cy',
  Da = 'da',
  Dag = 'dag',
  De = 'de',
  Dv = 'dv',
  Dz = 'dz',
  Ee = 'ee',
  El = 'el',
  En = 'en',
  Eo = 'eo',
  Es = 'es',
  Et = 'et',
  Eu = 'eu',
  Fa = 'fa',
  Ff = 'ff',
  Fi = 'fi',
  Fil = 'fil',
  Fj = 'fj',
  Fo = 'fo',
  Fr = 'fr',
  Fy = 'fy',
  Ga = 'ga',
  Gd = 'gd',
  Gl = 'gl',
  Gn = 'gn',
  Gu = 'gu',
  Gv = 'gv',
  Ha = 'ha',
  He = 'he',
  Hi = 'hi',
  Ho = 'ho',
  Hr = 'hr',
  Ht = 'ht',
  Hu = 'hu',
  Hy = 'hy',
  Hz = 'hz',
  Ia = 'ia',
  Id = 'id',
  Ie = 'ie',
  Ig = 'ig',
  Ii = 'ii',
  Ik = 'ik',
  Io = 'io',
  Is = 'is',
  It = 'it',
  Iu = 'iu',
  Ja = 'ja',
  Jv = 'jv',
  Ka = 'ka',
  Kg = 'kg',
  Ki = 'ki',
  Kj = 'kj',
  Kk = 'kk',
  Kl = 'kl',
  Km = 'km',
  Kn = 'kn',
  Ko = 'ko',
  Kr = 'kr',
  Ks = 'ks',
  Ku = 'ku',
  Kv = 'kv',
  Kw = 'kw',
  Ky = 'ky',
  La = 'la',
  Lb = 'lb',
  Lg = 'lg',
  Li = 'li',
  Ln = 'ln',
  Lo = 'lo',
  Lt = 'lt',
  Lu = 'lu',
  Lv = 'lv',
  Mg = 'mg',
  Mh = 'mh',
  Mi = 'mi',
  Mk = 'mk',
  Ml = 'ml',
  Mn = 'mn',
  Mo = 'mo',
  Mr = 'mr',
  Ms = 'ms',
  Mt = 'mt',
  My = 'my',
  Na = 'na',
  Nb = 'nb',
  Nd = 'nd',
  Ne = 'ne',
  Ng = 'ng',
  Nl = 'nl',
  Nn = 'nn',
  No = 'no',
  Nr = 'nr',
  Nso = 'nso',
  Nv = 'nv',
  Ny = 'ny',
  Oc = 'oc',
  Oj = 'oj',
  Om = 'om',
  Or = 'or',
  Os = 'os',
  Pa = 'pa',
  Pi = 'pi',
  Pl = 'pl',
  Ps = 'ps',
  Pt = 'pt',
  Qu = 'qu',
  Rm = 'rm',
  Rn = 'rn',
  Ro = 'ro',
  Ru = 'ru',
  Rw = 'rw',
  Sa = 'sa',
  Sc = 'sc',
  Sd = 'sd',
  Se = 'se',
  Sg = 'sg',
  Si = 'si',
  Sk = 'sk',
  Sl = 'sl',
  Sm = 'sm',
  Sn = 'sn',
  So = 'so',
  Sq = 'sq',
  Sr = 'sr',
  Ss = 'ss',
  St = 'st',
  Su = 'su',
  Sv = 'sv',
  Sw = 'sw',
  Ta = 'ta',
  Te = 'te',
  Tg = 'tg',
  Th = 'th',
  Ti = 'ti',
  Tk = 'tk',
  Tl = 'tl',
  Tn = 'tn',
  To = 'to',
  Tr = 'tr',
  Ts = 'ts',
  Tt = 'tt',
  Tw = 'tw',
  Ty = 'ty',
  Ug = 'ug',
  Uk = 'uk',
  Ur = 'ur',
  Uz = 'uz',
  Ve = 've',
  Vi = 'vi',
  Vo = 'vo',
  Wa = 'wa',
  Wo = 'wo',
  Xh = 'xh',
  Yi = 'yi',
  Yo = 'yo',
  Yue = 'yue',
  Za = 'za',
  Zh = 'zh',
  Zu = 'zu',
}

export const mapLanguage = new Map([
  [EnumLanguage.Aa, 'language.aa'],
  [EnumLanguage.Ab, 'language.ab'],
  [EnumLanguage.Ae, 'language.ae'],
  [EnumLanguage.Af, 'language.af'],
  [EnumLanguage.Ak, 'language.ak'],
  [EnumLanguage.Am, 'language.am'],
  [EnumLanguage.An, 'language.an'],
  [EnumLanguage.Ar, 'language.ar'],
  [EnumLanguage.As, 'language.as'],
  [EnumLanguage.Av, 'language.av'],
  [EnumLanguage.Ay, 'language.ay'],
  [EnumLanguage.Az, 'language.az'],
  [EnumLanguage.Ba, 'language.ba'],
  [EnumLanguage.Be, 'language.be'],
  [EnumLanguage.Bg, 'language.bg'],
  [EnumLanguage.Bi, 'language.bi'],
  [EnumLanguage.Bm, 'language.bm'],
  [EnumLanguage.Bn, 'language.bn'],
  [EnumLanguage.Bo, 'language.bo'],
  [EnumLanguage.Br, 'language.br'],
  [EnumLanguage.Bs, 'language.bs'],
  [EnumLanguage.Ca, 'language.ca'],
  [EnumLanguage.Ce, 'language.ce'],
  [EnumLanguage.Ch, 'language.ch'],
  [EnumLanguage.Cnr, 'language.cnr'],
  [EnumLanguage.Co, 'language.co'],
  [EnumLanguage.Cr, 'language.cr'],
  [EnumLanguage.Cs, 'language.cs'],
  [EnumLanguage.Cu, 'language.cu'],
  [EnumLanguage.Cy, 'language.cy'],
  [EnumLanguage.Da, 'language.da'],
  [EnumLanguage.Dag, 'language.dag'],
  [EnumLanguage.De, 'language.de'],
  [EnumLanguage.Dv, 'language.dv'],
  [EnumLanguage.Dz, 'language.dz'],
  [EnumLanguage.Ee, 'language.ee'],
  [EnumLanguage.El, 'language.el'],
  [EnumLanguage.En, 'language.en'],
  [EnumLanguage.Eo, 'language.eo'],
  [EnumLanguage.Es, 'language.es'],
  [EnumLanguage.Et, 'language.et'],
  [EnumLanguage.Eu, 'language.eu'],
  [EnumLanguage.Fa, 'language.fa'],
  [EnumLanguage.Ff, 'language.ff'],
  [EnumLanguage.Fi, 'language.fi'],
  [EnumLanguage.Fil, 'language.fil'],
  [EnumLanguage.Fj, 'language.fj'],
  [EnumLanguage.Fo, 'language.fo'],
  [EnumLanguage.Fr, 'language.fr'],
  [EnumLanguage.Fy, 'language.fy'],
  [EnumLanguage.Ga, 'language.ga'],
  [EnumLanguage.Gd, 'language.gd'],
  [EnumLanguage.Gl, 'language.gl'],
  [EnumLanguage.Gn, 'language.gn'],
  [EnumLanguage.Gu, 'language.gu'],
  [EnumLanguage.Gv, 'language.gv'],
  [EnumLanguage.Ha, 'language.ha'],
  [EnumLanguage.He, 'language.he'],
  [EnumLanguage.Hi, 'language.hi'],
  [EnumLanguage.Ho, 'language.ho'],
  [EnumLanguage.Hr, 'language.hr'],
  [EnumLanguage.Ht, 'language.ht'],
  [EnumLanguage.Hu, 'language.hu'],
  [EnumLanguage.Hy, 'language.hy'],
  [EnumLanguage.Hz, 'language.hz'],
  [EnumLanguage.Ia, 'language.ia'],
  [EnumLanguage.Id, 'language.id'],
  [EnumLanguage.Ie, 'language.ie'],
  [EnumLanguage.Ig, 'language.ig'],
  [EnumLanguage.Ii, 'language.ii'],
  [EnumLanguage.Ik, 'language.ik'],
  [EnumLanguage.Io, 'language.io'],
  [EnumLanguage.Is, 'language.is'],
  [EnumLanguage.It, 'language.it'],
  [EnumLanguage.Iu, 'language.iu'],
  [EnumLanguage.Ja, 'language.ja'],
  [EnumLanguage.Jv, 'language.jv'],
  [EnumLanguage.Ka, 'language.ka'],
  [EnumLanguage.Kg, 'language.kg'],
  [EnumLanguage.Ki, 'language.ki'],
  [EnumLanguage.Kj, 'language.kj'],
  [EnumLanguage.Kk, 'language.kk'],
  [EnumLanguage.Kl, 'language.kl'],
  [EnumLanguage.Km, 'language.km'],
  [EnumLanguage.Kn, 'language.kn'],
  [EnumLanguage.Ko, 'language.ko'],
  [EnumLanguage.Kr, 'language.kr'],
  [EnumLanguage.Ks, 'language.ks'],
  [EnumLanguage.Ku, 'language.ku'],
  [EnumLanguage.Kv, 'language.kv'],
  [EnumLanguage.Kw, 'language.kw'],
  [EnumLanguage.Ky, 'language.ky'],
  [EnumLanguage.La, 'language.la'],
  [EnumLanguage.Lb, 'language.lb'],
  [EnumLanguage.Lg, 'language.lg'],
  [EnumLanguage.Li, 'language.li'],
  [EnumLanguage.Ln, 'language.ln'],
  [EnumLanguage.Lo, 'language.lo'],
  [EnumLanguage.Lt, 'language.lt'],
  [EnumLanguage.Lu, 'language.lu'],
  [EnumLanguage.Lv, 'language.lv'],
  [EnumLanguage.Mg, 'language.mg'],
  [EnumLanguage.Mh, 'language.mh'],
  [EnumLanguage.Mi, 'language.mi'],
  [EnumLanguage.Mk, 'language.mk'],
  [EnumLanguage.Ml, 'language.ml'],
  [EnumLanguage.Mn, 'language.mn'],
  [EnumLanguage.Mo, 'language.mo'],
  [EnumLanguage.Mr, 'language.mr'],
  [EnumLanguage.Ms, 'language.ms'],
  [EnumLanguage.Mt, 'language.mt'],
  [EnumLanguage.My, 'language.my'],
  [EnumLanguage.Na, 'language.na'],
  [EnumLanguage.Nb, 'language.nb'],
  [EnumLanguage.Nd, 'language.nd'],
  [EnumLanguage.Ne, 'language.ne'],
  [EnumLanguage.Ng, 'language.ng'],
  [EnumLanguage.Nl, 'language.nl'],
  [EnumLanguage.Nn, 'language.nn'],
  [EnumLanguage.No, 'language.no'],
  [EnumLanguage.Nr, 'language.nr'],
  [EnumLanguage.Nso, 'language.nso'],
  [EnumLanguage.Nv, 'language.nv'],
  [EnumLanguage.Ny, 'language.ny'],
  [EnumLanguage.Oc, 'language.oc'],
  [EnumLanguage.Oj, 'language.oj'],
  [EnumLanguage.Om, 'language.om'],
  [EnumLanguage.Or, 'language.or'],
  [EnumLanguage.Os, 'language.os'],
  [EnumLanguage.Pa, 'language.pa'],
  [EnumLanguage.Pi, 'language.pi'],
  [EnumLanguage.Pl, 'language.pl'],
  [EnumLanguage.Ps, 'language.ps'],
  [EnumLanguage.Pt, 'language.pt'],
  [EnumLanguage.Qu, 'language.qu'],
  [EnumLanguage.Rm, 'language.rm'],
  [EnumLanguage.Rn, 'language.rn'],
  [EnumLanguage.Ro, 'language.ro'],
  [EnumLanguage.Ru, 'language.ru'],
  [EnumLanguage.Rw, 'language.rw'],
  [EnumLanguage.Sa, 'language.sa'],
  [EnumLanguage.Sc, 'language.sc'],
  [EnumLanguage.Sd, 'language.sd'],
  [EnumLanguage.Se, 'language.se'],
  [EnumLanguage.Sg, 'language.sg'],
  [EnumLanguage.Si, 'language.si'],
  [EnumLanguage.Sk, 'language.sk'],
  [EnumLanguage.Sl, 'language.sl'],
  [EnumLanguage.Sm, 'language.sm'],
  [EnumLanguage.Sn, 'language.sn'],
  [EnumLanguage.So, 'language.so'],
  [EnumLanguage.Sq, 'language.sq'],
  [EnumLanguage.Sr, 'language.sr'],
  [EnumLanguage.Ss, 'language.ss'],
  [EnumLanguage.St, 'language.st'],
  [EnumLanguage.Su, 'language.su'],
  [EnumLanguage.Sv, 'language.sv'],
  [EnumLanguage.Sw, 'language.sw'],
  [EnumLanguage.Ta, 'language.ta'],
  [EnumLanguage.Te, 'language.te'],
  [EnumLanguage.Tg, 'language.tg'],
  [EnumLanguage.Th, 'language.th'],
  [EnumLanguage.Ti, 'language.ti'],
  [EnumLanguage.Tk, 'language.tk'],
  [EnumLanguage.Tl, 'language.tl'],
  [EnumLanguage.Tn, 'language.tn'],
  [EnumLanguage.To, 'language.to'],
  [EnumLanguage.Tr, 'language.tr'],
  [EnumLanguage.Ts, 'language.ts'],
  [EnumLanguage.Tt, 'language.tt'],
  [EnumLanguage.Tw, 'language.tw'],
  [EnumLanguage.Ty, 'language.ty'],
  [EnumLanguage.Ug, 'language.ug'],
  [EnumLanguage.Uk, 'language.uk'],
  [EnumLanguage.Ur, 'language.ur'],
  [EnumLanguage.Uz, 'language.uz'],
  [EnumLanguage.Ve, 'language.ve'],
  [EnumLanguage.Vi, 'language.vi'],
  [EnumLanguage.Vo, 'language.vo'],
  [EnumLanguage.Wa, 'language.wa'],
  [EnumLanguage.Wo, 'language.wo'],
  [EnumLanguage.Xh, 'language.xh'],
  [EnumLanguage.Yi, 'language.yi'],
  [EnumLanguage.Yo, 'language.yo'],
  [EnumLanguage.Yue, 'language.yue'],
  [EnumLanguage.Za, 'language.za'],
  [EnumLanguage.Zh, 'language.zh'],
  [EnumLanguage.Zu, 'language.zu'],
]);

export enum LogEventType {
  Flag = 'flag',
}

export enum EnumEventType {
  Milestone = 'milestone',
  Event = 'event',
  Task = 'task',
  Subtask = 'subtask',
  Payment = 'payment',
  PitchDeadline = 'pitch_deadline',
}

export enum EnumProjectContractStatus {
  Accepted = 'accepted',
  Negotiation = 'negotiation',
  Canceled = 'canceled',
  Draft = 'draft',
  Active = 'active',
}

export enum EnumProjectHourlyRate {
  Bt_25_49 = 'bt_25_49',
  Bt_50_99 = 'bt_50_99',
  Bt_100_149 = 'bt_100_149',
  Bt_150_199 = 'bt_150_199',
  Bt_200_299 = 'bt_200_299',
  Gte_300 = 'gte_300',
  Lt_25 = 'lt_25',
  NA = 'n_a',
}

export const mapHourlyRate = new Map([
  [EnumProjectHourlyRate.Lt_25, '< 25'],
  [EnumProjectHourlyRate.Bt_25_49, '25 - 49'],
  [EnumProjectHourlyRate.Bt_50_99, '50 - 99'],
  [EnumProjectHourlyRate.Bt_100_149, '100 - 149'],
  [EnumProjectHourlyRate.Bt_150_199, '150 - 199'],
  [EnumProjectHourlyRate.Bt_200_299, '200 - 299'],
  [EnumProjectHourlyRate.Gte_300, '300+'],
  [EnumProjectHourlyRate.NA, 'n_a'],
]);

export enum EnumProjectMilestoneStatus {
  Approved = 'approved',
  Completed = 'completed',
  InProgress = 'in_progress',
  Negotiation = 'negotiation',
  Pending = 'pending',
  UnderReview = 'under_review',
}

export enum EnumProjectPaymentStatus {
  Completed = 'completed',
  PendingBuyerInvoice = 'pending_buyer_invoice',
  PendingBuyerPayment = 'pending_buyer_payment',
  PendingMilestoneApproval = 'pending_milestone_approval',
  PendingSellerInvoice = 'pending_seller_invoice',
  PendingSellerPayment = 'pending_seller_payment',
}

export enum EnumProjectSize {
  Bt_5k_10k = 'bt_5k_10k',
  Bt_10k_25k = 'bt_10k_25k',
  Bt_25k_50k = 'bt_25k_50k',
  Bt_50k_75k = 'bt_50k_75k',
  Bt_75k_100k = 'bt_75k_100k',
  Bt_100k_150k = 'bt_100k_150k',
  Bt_150k_200k = 'bt_150k_200k',
  Bt_200k_250k = 'bt_200k_250k',
  Gt_250k = 'gt_250k',
  Lt_5k = 'lt_5k',
}

export const mapProjectSize = new Map([
  [EnumProjectSize.Bt_5k_10k, '5,000 - 10,000'],
  [EnumProjectSize.Bt_10k_25k, '10,000 - 25,000'],
  [EnumProjectSize.Bt_25k_50k, '25,000 - 50,000'],
  [EnumProjectSize.Bt_50k_75k, '50,000 - 75,000'],
  [EnumProjectSize.Bt_75k_100k, '75,000 - 100,000'],
  [EnumProjectSize.Bt_100k_150k, '100,000 - 150,000'],
  [EnumProjectSize.Bt_150k_200k, '150,000 - 200,000'],
  [EnumProjectSize.Bt_200k_250k, '200,000 - 250,000'],
  [EnumProjectSize.Gt_250k, '250,000+'],
  [EnumProjectSize.Lt_5k, '< 5,000'],
]);

export enum EnumProjectStatus {
  Canceled = 'canceled',
  Completed = 'completed',
  InProgress = 'in_progress',
  Pending = 'pending',
}

export enum EnumProjectSubtaskStatus {
  Canceled = 'canceled',
  Completed = 'completed',
  Pending = 'pending',
}

export enum EnumProjectTaskStatus {
  Canceled = 'canceled',
  Completed = 'completed',
  InProgress = 'in_progress',
  Pending = 'pending',
}

export enum EnumProjectType {
  OneTime = 'one_time',
  Retainer = 'retainer',
}

export enum EnumPublicationStatus {
  AwaitingApproval = 'awaiting_approval',
  Deleted = 'deleted',
  Draft = 'draft',
  Private = 'private',
  Public = 'public',
  Rejected = 'rejected',
}

export enum EnumService {
  Accounting = 'accounting',
  AirlinesAviation = 'airlines_aviation',
  AlternativeDisputeResolution = 'alternative_dispute_resolution',
  AlternativeMedicine = 'alternative_medicine',
  Animation = 'animation',
  AppDesign = 'app_design',
  AppDevelopment = 'app_development',
  ApparelAndFashion = 'apparel_and_fashion',
  ArchitectureAndPlanning = 'architecture_and_planning',
  ArtsAndCrafts = 'arts_and_crafts',
  AugmentedReality = 'augmented_reality',
  Automotive = 'automotive',
  AviationAndAerospace = 'aviation_and_aerospace',
  Banking = 'banking',
  Biotechnology = 'biotechnology',
  Blockchain = 'blockchain',
  Branding = 'branding',
  BroadcastMedia = 'broadcast_media',
  BuildingMaterials = 'building_materials',
  BusinessSuppliesAndEquipment = 'business_supplies_and_equipment',
  CapitalMarkets = 'capital_markets',
  CgiProduction = 'cgi_production',
  Chatbot = 'chatbot',
  Chemicals = 'chemicals',
  CivicSocialOrganization = 'civic_social_organization',
  CivilEngineering = 'civil_engineering',
  CommercialRealEstate = 'commercial_real_estate',
  CommunityManagement = 'community_management',
  ComputerAndNetworkSecurity = 'computer_and_network_security',
  ComputerGames = 'computer_games',
  ComputerHardware = 'computer_hardware',
  ComputerNetworking = 'computer_networking',
  ComputerSoftware = 'computer_software',
  Construction = 'construction',
  ConsumerElectronics = 'consumer_electronics',
  ConsumerGoods = 'consumer_goods',
  ConsumerServices = 'consumer_services',
  ContentMarketing = 'content_marketing',
  Copywriting = 'copywriting',
  Cosmetics = 'cosmetics',
  Dairy = 'dairy',
  DataAnalytics = 'data_analytics',
  DataEngineering = 'data_engineering',
  DataScience = 'data_science',
  DefenseAndSpace = 'defense_and_space',
  Design = 'design',
  DesignStrategy = 'design_strategy',
  DevOps = 'devops',
  DigitalStrategy = 'digital_strategy',
  Ecommerce = 'ecommerce',
  Elearning = 'elearning',
  EducationManagement = 'education_management',
  ElectricalOrElectronicManufacturing = 'electrical_or_electronic_manufacturing',
  EmailMarketing = 'email_marketing',
  Energy = 'energy',
  Entertainment = 'entertainment',
  EnvironmentalServices = 'environmental_services',
  EventMarketing = 'event_marketing',
  Events = 'events',
  ExecutiveOffice = 'executive_office',
  ExtendedReality = 'extended_reality',
  FacilitiesServices = 'facilities_services',
  Farming = 'farming',
  FastMovingConsumerGoods = 'fast_moving_consumer_goods',
  FinancialServices = 'financial_services',
  FineArt = 'fine_art',
  Fishery = 'fishery',
  FoodAndBeverages = 'food_and_beverages',
  FoodProduction = 'food_production',
  Fundraising = 'fundraising',
  Furniture = 'furniture',
  GamblingAndCasinos = 'gambling_and_casinos',
  GameDevelopment = 'game_development',
  GlassCeramicsAndConcrete = 'glass_ceramics_and_concrete',
  GovernmentAdministration = 'government_administration',
  GovernmentRelations = 'government_relations',
  GraphicDesign = 'graphic_design',
  HealthWellnessAndFitness = 'health_wellness_and_fitness',
  HigherEducation = 'higher_education',
  HospitalAndHealthCare = 'hospital_and_health_care',
  Hospitality = 'hospitality',
  HumanResources = 'human_resources',
  ImportAndExport = 'import_and_export',
  IndividualAndFamilyServices = 'individual_and_family_services',
  IndustrialAutomation = 'industrial_automation',
  InfluencerMarketing = 'influencer_marketing',
  InformationServices = 'information_services',
  InformationTechnology = 'information_technology',
  InstoreMarketing = 'instore_marketing',
  Insurance = 'insurance',
  InternationalAffairs = 'international_affairs',
  InternationalTradeAndDevelopment = 'international_trade_and_development',
  Internet = 'internet',
  InvestmentBanking = 'investment_banking',
  InvestmentManagement = 'investment_management',
  Judiciary = 'judiciary',
  LawEnforcement = 'law_enforcement',
  LawPractice = 'law_practice',
  LegalServices = 'legal_services',
  LegislativeOffice = 'legislative_office',
  LeisureTravelAndTourism = 'leisure_travel_and_tourism',
  Libraries = 'libraries',
  LogisticsAndSupplyChain = 'logistics_and_supply_chain',
  LuxuryGoodsAndJewelry = 'luxury_goods_and_jewelry',
  MachineLearning = 'machine_learning',
  Machinery = 'machinery',
  ManagementConsulting = 'management_consulting',
  Maritime = 'maritime',
  MarketResearch = 'market_research',
  MarketingAndAdvertising = 'marketing_and_advertising',
  MechanicalOrIndustrialEngineering = 'mechanical_or_industrial_engineering',
  MediaBuying = 'media_buying',
  MediaProduction = 'media_production',
  MedicalDevices = 'medical_devices',
  MedicalPractice = 'medical_practice',
  MentalHealthCare = 'mental_health_care',
  Military = 'military',
  MiningAndMetals = 'mining_and_metals',
  MobileAdvertising = 'mobile_advertising',
  MobileAppDesign = 'mobile_app_design',
  MobileAppDevelopment = 'mobile_app_development',
  MotionDesign = 'motion_design',
  MotionPicturesAndFilm = 'motion_pictures_and_film',
  MuseumsAndInstitutions = 'museums_and_institutions',
  Music = 'music',
  Nanotechnology = 'nanotechnology',
  Newspapers = 'newspapers',
  NonprofitOrganizationManagement = 'nonprofit_organization_management',
  OilAndGas = 'oil_and_gas',
  OnlineMedia = 'online_media',
  OutsourcingAndOffshoring = 'outsourcing_and_offshoring',
  PackageAndFreightDelivery = 'package_and_freight_delivery',
  PackagingAndContainers = 'packaging_and_containers',
  PaidSearchMarketing = 'paid_search_marketing',
  PaperAndForestProducts = 'paper_and_forest_products',
  PerformingArts = 'performing_arts',
  PerformanceMarketing = 'performance_marketing',
  Pharmaceuticals = 'pharmaceuticals',
  Philanthropy = 'philanthropy',
  Photography = 'photography',
  Plastics = 'plastics',
  PoliticalOrganization = 'political_organization',
  PrimarySecondaryEducation = 'primary_secondary_education',
  Printing = 'printing',
  ProfessionalTrainingAndCoaching = 'professional_training_and_coaching',
  ProgramDevelopment = 'program_development',
  PublicPolicy = 'public_policy',
  PublicRelationsAndCommunications = 'public_relations_and_communications',
  PublicRelations = 'public_relations',
  PublicSafety = 'public_safety',
  Publishing = 'publishing',
  RailroadManufacture = 'railroad_manufacture',
  Ranching = 'ranching',
  RealEstate = 'real_estate',
  RecreationalFacilities = 'recreational_facilities',
  ReligiousInstitutions = 'religious_institutions',
  RenewablesAndEnvironment = 'renewables_and_environment',
  Research = 'research',
  Restaurants = 'restaurants',
  Retail = 'retail',
  SearchEngineOptimization = 'search_engine_optimization',
  SecurityAndInvestigations = 'security_and_investigations',
  Semiconductors = 'semiconductors',
  Shipbuilding = 'shipbuilding',
  SocialMediaAdvertising = 'social_media_advertising',
  SocialMediaManagement = 'social_media_management',
  SportingGoods = 'sporting_goods',
  Sports = 'sports',
  StaffingAndRecruiting = 'staffing_and_recruiting',
  Supermarkets = 'supermarkets',
  Telecommunications = 'telecommunications',
  Textiles = 'textiles',
  ThinkTanks = 'think_tanks',
  Tobacco = 'tobacco',
  TranslationAndLocalization = 'translation_and_localization',
  TransportationTruckingAndRailroad = 'transportation_trucking_and_railroad',
  UserExperienceDesign = 'user_experience_design',
  UserInterfaceDesign = 'user_interface_design',
  Utilities = 'utilities',
  VentureCapitalAndPrivateEquity = 'venture_capital_and_private_equity',
  Veterinary = 'veterinary',
  Video = 'video',
  VirtualReality = 'virtual_reality',
  Warehousing = 'warehousing',
  WebDesign = 'web_design',
  WebDevelopment = 'web_development',
  Wholesale = 'wholesale',
  WineAndSpirits = 'wine_and_spirits',
  Wireless = 'wireless',
  WritingAndEditing = 'writing_and_editing',
}

export const mapService = new Map([
  [EnumService.Accounting, 'service.accounting'],
  [EnumService.AirlinesAviation, 'service.airlines_aviation'],
  [EnumService.AlternativeDisputeResolution, 'service.alternative_dispute_resolution'],
  [EnumService.AlternativeMedicine, 'service.alternative_medicine'],
  [EnumService.Animation, 'service.animation'],
  [EnumService.AppDesign, 'service.app_design'],
  [EnumService.AppDevelopment, 'service.app_development'],
  [EnumService.ApparelAndFashion, 'service.apparel_and_fashion'],
  [EnumService.ArchitectureAndPlanning, 'service.architecture_and_planning'],
  [EnumService.ArtsAndCrafts, 'service.arts_and_crafts'],
  [EnumService.AugmentedReality, 'service.augmented_reality'],
  [EnumService.Automotive, 'service.automotive'],
  [EnumService.AviationAndAerospace, 'service.aviation_and_aerospace'],
  [EnumService.Banking, 'service.banking'],
  [EnumService.Biotechnology, 'service.biotechnology'],
  [EnumService.Blockchain, 'service.blockchain'],
  [EnumService.Branding, 'service.branding'],
  [EnumService.BroadcastMedia, 'service.broadcast_media'],
  [EnumService.BuildingMaterials, 'service.building_materials'],
  [EnumService.BusinessSuppliesAndEquipment, 'service.business_supplies_and_equipment'],
  [EnumService.CapitalMarkets, 'service.capital_markets'],
  [EnumService.CgiProduction, 'service.cgi_production'],
  [EnumService.Chatbot, 'service.chatbot'],
  [EnumService.Chemicals, 'service.chemicals'],
  [EnumService.CivicSocialOrganization, 'service.civic_social_organization'],
  [EnumService.CivilEngineering, 'service.civil_engineering'],
  [EnumService.CommercialRealEstate, 'service.commercial_real_estate'],
  [EnumService.CommunityManagement, 'service.community_management'],
  [EnumService.ComputerAndNetworkSecurity, 'service.computer_and_network_security'],
  [EnumService.ComputerGames, 'service.computer_games'],
  [EnumService.ComputerHardware, 'service.computer_hardware'],
  [EnumService.ComputerNetworking, 'service.computer_networking'],
  [EnumService.ComputerSoftware, 'service.computer_software'],
  [EnumService.Construction, 'service.construction'],
  [EnumService.ConsumerElectronics, 'service.consumer_electronics'],
  [EnumService.ConsumerGoods, 'service.consumer_goods'],
  [EnumService.ConsumerServices, 'service.consumer_services'],
  [EnumService.ContentMarketing, 'service.content_marketing'],
  [EnumService.Copywriting, 'service.copywriting'],
  [EnumService.Cosmetics, 'service.cosmetics'],
  [EnumService.Dairy, 'service.dairy'],
  [EnumService.DataAnalytics, 'service.data_analytics'],
  [EnumService.DataEngineering, 'service.data_engineering'],
  [EnumService.DataScience, 'service.data_science'],
  [EnumService.DefenseAndSpace, 'service.defense_and_space'],
  [EnumService.Design, 'service.design'],
  [EnumService.DesignStrategy, 'service.design_strategy'],
  [EnumService.DevOps, 'service.devops'],
  [EnumService.DigitalStrategy, 'service.digital_strategy'],
  [EnumService.Ecommerce, 'service.ecommerce'],
  [EnumService.Elearning, 'service.elearning'],
  [EnumService.EducationManagement, 'service.education_management'],
  [EnumService.ElectricalOrElectronicManufacturing, 'service.electrical_or_electronic_manufacturing'],
  [EnumService.Energy, 'service.energy'],
  [EnumService.Entertainment, 'service.entertainment'],
  [EnumService.EnvironmentalServices, 'service.environmental_services'],
  [EnumService.EventMarketing, 'service.event_marketing'],
  [EnumService.Events, 'service.events'],
  [EnumService.ExecutiveOffice, 'service.executive_office'],
  [EnumService.ExtendedReality, 'service.extended_reality'],
  [EnumService.FacilitiesServices, 'service.facilities_services'],
  [EnumService.Farming, 'service.farming'],
  [EnumService.FastMovingConsumerGoods, 'service.fast_moving_consumer_goods'],
  [EnumService.FinancialServices, 'service.financial_services'],
  [EnumService.FineArt, 'service.fine_art'],
  [EnumService.Fishery, 'service.fishery'],
  [EnumService.FoodAndBeverages, 'service.food_and_beverages'],
  [EnumService.FoodProduction, 'service.food_production'],
  [EnumService.Fundraising, 'service.fundraising'],
  [EnumService.Furniture, 'service.furniture'],
  [EnumService.GamblingAndCasinos, 'service.gambling_and_casinos'],
  [EnumService.GameDevelopment, 'service.game_development'],
  [EnumService.GlassCeramicsAndConcrete, 'service.glass_ceramics_and_concrete'],
  [EnumService.GovernmentAdministration, 'service.government_administration'],
  [EnumService.GovernmentRelations, 'service.government_relations'],
  [EnumService.GraphicDesign, 'service.graphic_design'],
  [EnumService.HealthWellnessAndFitness, 'service.health_wellness_and_fitness'],
  [EnumService.HigherEducation, 'service.higher_education'],
  [EnumService.HospitalAndHealthCare, 'service.hospital_and_health_care'],
  [EnumService.Hospitality, 'service.hospitality'],
  [EnumService.HumanResources, 'service.human_resources'],
  [EnumService.ImportAndExport, 'service.import_and_export'],
  [EnumService.IndividualAndFamilyServices, 'service.individual_and_family_services'],
  [EnumService.IndustrialAutomation, 'service.industrial_automation'],
  [EnumService.InfluencerMarketing, 'service.influencer_marketing'],
  [EnumService.InformationServices, 'service.information_services'],
  [EnumService.InformationTechnology, 'service.information_technology'],
  [EnumService.InstoreMarketing, 'service.instore_marketing'],
  [EnumService.Insurance, 'service.insurance'],
  [EnumService.InternationalAffairs, 'service.international_affairs'],
  [EnumService.InternationalTradeAndDevelopment, 'service.international_trade_and_development'],
  [EnumService.Internet, 'service.internet'],
  [EnumService.InvestmentBanking, 'service.investment_banking'],
  [EnumService.InvestmentManagement, 'service.investment_management'],
  [EnumService.Judiciary, 'service.judiciary'],
  [EnumService.LawEnforcement, 'service.law_enforcement'],
  [EnumService.LawPractice, 'service.law_practice'],
  [EnumService.LegalServices, 'service.legal_services'],
  [EnumService.LegislativeOffice, 'service.legislative_office'],
  [EnumService.LeisureTravelAndTourism, 'service.leisure_travel_and_tourism'],
  [EnumService.Libraries, 'service.libraries'],
  [EnumService.LogisticsAndSupplyChain, 'service.logistics_and_supply_chain'],
  [EnumService.LuxuryGoodsAndJewelry, 'service.luxury_goods_and_jewelry'],
  [EnumService.MachineLearning, 'service.machine_learning'],
  [EnumService.Machinery, 'service.machinery'],
  [EnumService.ManagementConsulting, 'service.management_consulting'],
  [EnumService.Maritime, 'service.maritime'],
  [EnumService.MarketResearch, 'service.market_research'],
  [EnumService.MarketingAndAdvertising, 'service.marketing_and_advertising'],
  [EnumService.MechanicalOrIndustrialEngineering, 'service.mechanical_or_industrial_engineering'],
  [EnumService.MediaBuying, 'service.media_buying'],
  [EnumService.MediaProduction, 'service.media_production'],
  [EnumService.MedicalDevices, 'service.medical_devices'],
  [EnumService.MedicalPractice, 'service.medical_practice'],
  [EnumService.MentalHealthCare, 'service.mental_health_care'],
  [EnumService.Military, 'service.military'],
  [EnumService.MiningAndMetals, 'service.mining_and_metals'],
  [EnumService.MobileAdvertising, 'service.mobile_advertising'],
  [EnumService.MobileAppDesign, 'service.mobile_app_design'],
  [EnumService.MobileAppDevelopment, 'service.mobile_app_development'],
  [EnumService.MotionDesign, 'service.motion_design'],
  [EnumService.MotionPicturesAndFilm, 'service.motion_pictures_and_film'],
  [EnumService.MuseumsAndInstitutions, 'service.museums_and_institutions'],
  [EnumService.Music, 'service.music'],
  [EnumService.Nanotechnology, 'service.nanotechnology'],
  [EnumService.Newspapers, 'service.newspapers'],
  [EnumService.NonprofitOrganizationManagement, 'service.nonprofit_organization_management'],
  [EnumService.OilAndGas, 'service.oil_and_gas'],
  [EnumService.OnlineMedia, 'service.online_media'],
  [EnumService.OutsourcingAndOffshoring, 'service.outsourcing_and_offshoring'],
  [EnumService.PackageAndFreightDelivery, 'service.package_and_freight_delivery'],
  [EnumService.PackagingAndContainers, 'service.packaging_and_containers'],
  [EnumService.PaidSearchMarketing, 'service.paid_search_marketing'],
  [EnumService.PaperAndForestProducts, 'service.paper_and_forest_products'],
  [EnumService.PerformingArts, 'service.performing_arts'],
  [EnumService.PerformanceMarketing, 'service.performance_marketing'],
  [EnumService.Pharmaceuticals, 'service.pharmaceuticals'],
  [EnumService.Philanthropy, 'service.philanthropy'],
  [EnumService.Photography, 'service.photography'],
  [EnumService.Plastics, 'service.plastics'],
  [EnumService.PoliticalOrganization, 'service.political_organization'],
  [EnumService.PrimarySecondaryEducation, 'service.primary_secondary_education'],
  [EnumService.Printing, 'service.printing'],
  [EnumService.ProfessionalTrainingAndCoaching, 'service.professional_training_and_coaching'],
  [EnumService.ProgramDevelopment, 'service.program_development'],
  [EnumService.PublicPolicy, 'service.public_policy'],
  [EnumService.PublicRelations, 'service.public_relations'],
  [EnumService.PublicRelationsAndCommunications, 'service.public_relations_and_communications'],
  [EnumService.PublicSafety, 'service.public_safety'],
  [EnumService.Publishing, 'service.publishing'],
  [EnumService.RailroadManufacture, 'service.railroad_manufacture'],
  [EnumService.Ranching, 'service.ranching'],
  [EnumService.RealEstate, 'service.real_estate'],
  [EnumService.RecreationalFacilities, 'service.recreational_facilities'],
  [EnumService.ReligiousInstitutions, 'service.religious_institutions'],
  [EnumService.RenewablesAndEnvironment, 'service.renewables_and_environment'],
  [EnumService.Research, 'service.research'],
  [EnumService.Restaurants, 'service.restaurants'],
  [EnumService.Retail, 'service.retail'],
  [EnumService.SearchEngineOptimization, 'service.search_engine_optimization'],
  [EnumService.SecurityAndInvestigations, 'service.security_and_investigations'],
  [EnumService.Semiconductors, 'service.semiconductors'],
  [EnumService.Shipbuilding, 'service.shipbuilding'],
  [EnumService.SocialMediaAdvertising, 'service.social_media_advertising'],
  [EnumService.SocialMediaManagement, 'service.social_media_management'],
  [EnumService.SportingGoods, 'service.sporting_goods'],
  [EnumService.Sports, 'service.sports'],
  [EnumService.StaffingAndRecruiting, 'service.staffing_and_recruiting'],
  [EnumService.Supermarkets, 'service.supermarkets'],
  [EnumService.Telecommunications, 'service.telecommunications'],
  [EnumService.Textiles, 'service.textiles'],
  [EnumService.ThinkTanks, 'service.think_tanks'],
  [EnumService.Tobacco, 'service.tobacco'],
  [EnumService.TranslationAndLocalization, 'service.translation_and_localization'],
  [EnumService.TransportationTruckingAndRailroad, 'service.transportation_trucking_and_railroad'],
  [EnumService.UserExperienceDesign, 'service.user_experience_design'],
  [EnumService.UserInterfaceDesign, 'service.user_interface_design'],
  [EnumService.Utilities, 'service.utilities'],
  [EnumService.VentureCapitalAndPrivateEquity, 'service.venture_capital_and_private_equity'],
  [EnumService.Veterinary, 'service.veterinary'],
  [EnumService.Video, 'service.video'],
  [EnumService.VirtualReality, 'service.virtual_reality'],
  [EnumService.Warehousing, 'service.warehousing'],
  [EnumService.WebDesign, 'service.web_design'],
  [EnumService.WebDevelopment, 'service.web_development'],
  [EnumService.Wholesale, 'service.wholesale'],
  [EnumService.WineAndSpirits, 'service.wine_and_spirits'],
  [EnumService.Wireless, 'service.wireless'],
  [EnumService.WritingAndEditing, 'service.writing_and_editing'],
]);

export enum EnumTechLanguage {
  Apl = 'apl',
  Assembly = 'assembly',
  C = 'c',
  Cobol = 'cobol',
  Clojure = 'clojure',
  Cpp = 'cpp',
  Crystal = 'crystal',
  Csharp = 'csharp',
  Dart = 'dart',
  Delphi = 'delphi',
  Elixir = 'elixir',
  Erlang = 'erlang',
  Fsharp = 'fsharp',
  Go = 'go',
  Groovy = 'groovy',
  HtmlAndCss = 'html_and_css',
  Haskell = 'haskell',
  Java = 'java',
  JavaScript = 'javascript',
  Julia = 'julia',
  Kotlin = 'kotlin',
  Lisp = 'lisp',
  Matlab = 'matlab',
  ObjectiveC = 'objective_c',
  Php = 'php',
  Perl = 'perl',
  PowerShell = 'powershell',
  Python = 'python',
  R = 'r',
  Ruby = 'ruby',
  Rust = 'rust',
  Sql = 'sql',
  Scala = 'scala',
  Swift = 'swift',
  TypeScript = 'typescript',
  UnixShell = 'unix_shell',
  VisualBasic = 'visual_basic',
}

export const mapTechLanguage = new Map([
  [EnumTechLanguage.Apl, 'APL'],
  [EnumTechLanguage.Assembly, 'Assembly'],
  [EnumTechLanguage.C, 'C'],
  [EnumTechLanguage.Cobol, 'COBOL'],
  [EnumTechLanguage.Clojure, 'Clojure'],
  [EnumTechLanguage.Cpp, 'C++'],
  [EnumTechLanguage.Crystal, 'Crystal'],
  [EnumTechLanguage.Csharp, 'C#'],
  [EnumTechLanguage.Dart, 'Dart'],
  [EnumTechLanguage.Delphi, 'Delphi'],
  [EnumTechLanguage.Elixir, 'Elixir'],
  [EnumTechLanguage.Erlang, 'Erlang'],
  [EnumTechLanguage.Fsharp, 'F#'],
  [EnumTechLanguage.Go, 'Go'],
  [EnumTechLanguage.Groovy, 'Groovy'],
  [EnumTechLanguage.HtmlAndCss, 'HTML & CSS'],
  [EnumTechLanguage.Haskell, 'Haskell'],
  [EnumTechLanguage.Java, 'Java'],
  [EnumTechLanguage.JavaScript, 'JavaScript'],
  [EnumTechLanguage.Julia, 'Julia'],
  [EnumTechLanguage.Kotlin, 'Kotlin'],
  [EnumTechLanguage.Lisp, 'Lisp'],
  [EnumTechLanguage.Matlab, 'MATLAB'],
  [EnumTechLanguage.ObjectiveC, 'Objective-C'],
  [EnumTechLanguage.Php, 'PHP'],
  [EnumTechLanguage.Perl, 'Perl'],
  [EnumTechLanguage.PowerShell, 'PowerShell'],
  [EnumTechLanguage.Python, 'Python'],
  [EnumTechLanguage.R, 'R'],
  [EnumTechLanguage.Ruby, 'Ruby'],
  [EnumTechLanguage.Rust, 'Rust'],
  [EnumTechLanguage.Sql, 'SQL'],
  [EnumTechLanguage.Scala, 'Scala'],
  [EnumTechLanguage.Swift, 'Swift'],
  [EnumTechLanguage.TypeScript, 'TypeScript'],
  [EnumTechLanguage.UnixShell, 'Unix Shell'],
  [EnumTechLanguage.VisualBasic, 'Visual Basic'],
]);

export enum EnumTechPlatform {
  AmazonWebServices = 'amazon_web_services',
  Android = 'android',
  Azure = 'azure',
  DigitalOcean = 'digitalocean',
  Docker = 'docker',
  GoogleCloud = 'google_cloud',
  Heroku = 'heroku',
  IbmCloud = 'ibm_cloud',
  Kubernetes = 'kubernetes',
  Lxc = 'lxc',
  Linux = 'linux',
  MacOs = 'macos',
  OracleCloud = 'oracle_cloud',
  SalesforcePlatform = 'salesforce_platform',
  Windows = 'windows',
  IOs = 'ios',
}

export enum EnumTechTool {
  AsPdotNet = 'aspdotnet',
  Angular = 'angular',
  AngularJs = 'angularjs',
  ApacheHBase = 'apache_hbase',
  ApacheSpark = 'apache_spark',
  BackboneJs = 'backbonejs',
  Bootstrap = 'bootstrap',
  CakePhp = 'cakephp',
  Cassandra = 'cassandra',
  Cordova = 'cordova',
  Django = 'django',
  Drupal = 'drupal',
  Elasticsearch = 'elasticsearch',
  Electron = 'electron',
  EmberJs = 'emberjs',
  Express = 'express',
  FastApi = 'fastapi',
  Firebase = 'firebase',
  Flask = 'flask',
  Flutter = 'flutter',
  Gatsby = 'gatsby',
  Hadoop = 'hadoop',
  IbmDb2 = 'ibm_db2',
  Joomla = 'joomla',
  Laravel = 'laravel',
  Meteor = 'meteor',
  MicrosoftSqlServer = 'microsoft_sql_server',
  MongoDb = 'mongodb',
  MySqlOrMariaDb = 'mysql_or_mariadb',
  NextJs = 'nextjs',
  NodeJs = 'nodejs',
  NumPy = 'numpy',
  OracleDatabase = 'oracle_database',
  Pandas = 'pandas',
  Play = 'play',
  PostgreSql = 'postgresql',
  PyTorch = 'pytorch',
  Qt = 'qt',
  Quasar = 'quasar',
  React = 'react',
  ReactNative = 'react_native',
  Redis = 'redis',
  RubyOnRails = 'ruby_on_rails',
  SqLite = 'sqlite',
  SailsJs = 'sailsjs',
  Spring = 'spring',
  Struts = 'struts',
  Svelte = 'svelte',
  Symfony = 'symfony',
  TensorFlow = 'tensorflow',
  Unity = 'unity',
  UnrealEngine = 'unreal_engine',
  VueJs = 'vuejs',
  WordPress = 'wordpress',
  DotNet = 'dotnet',
  JQuery = 'jquery',
}

export enum EnumToolType {
  Bar = 'bar',
  Baz = 'baz',
  Foo = 'foo',
}

export enum EnumVerificationStatus {
  TdaVerified = 'tda_verified',
  Unverified = 'unverified',
  Verified = 'verified',
}

export enum EnumTutorialStatus {
  ContractDetail = 'contract_detail_screen',
  EndToEnd = 'end_to_end',
  IndividualContractDetail = 'individual_contract_detail',
  IndividualPayment = 'individual_payment',
  MilestoneDetail = 'milestone_detail',
  PaymentDetail = 'payment_detail',
  ProjectDetail = 'project_detail',
  TaskDetail = 'task_detail',
  SubtaskDetail = 'subtask_detail',
  ActiveProjectDetail = 'active_project_detail',
}

export enum UserRoles {
  Verified = 'verified',
  Admin = 'admin',
}

export enum CompanyRole {
  Buyer = 'buyer',
  SellerTool = 'seller_tool',
  SellerService = 'seller_service',
}

export enum MembershipRole {
  Owner = 'owner',
  Admin = 'admin',
  Editor = 'editor',
}
export const mapMembershipRole = new Map([
  [MembershipRole.Owner, 'Owner'],
  [MembershipRole.Admin, 'Admin'],
  [MembershipRole.Editor, 'Editor'],
]);

export enum PaymentStatus {
  Pending = 'pending',
  InProgress = 'in_progress',
  Late = 'late',
  Paid = 'paid',
}

export enum EnumNotificationCategory {
  Content = 'content',
  Marketplace = 'marketplace',
  E2EManagment = 'e2e_managment',
  Achievements = 'achievements',
  TDCNotifications = 'tdc_notifications',
  Premium = 'premium',
  PostRegistration = 'post_registration',
  Calendar = 'calendar',
}

export enum EnumFlagStatus {
  New = 'new',
  InProgress = 'in_progress',
  Resolved = 'resolved',
}

export enum EnumNotificationType {
  Regular = 'regular',
  Blue = 'blue',
  Orange = 'orange',
  Green = 'green',
  Red = 'red',
}

export enum EnumScreenList {
  ProjectDetail = 'project_detail',
  MilestoneScreen = 'milestone_screen',
  TimedProjectScreen = 'timed_project_screen',
  TimedProjectDetailScreen = 'timed_project_detail_screen',
  PitchScreen = 'pitch_screen',
  PitchDetailScreen = 'pitch_detail_screen',
  CaseStudyScreen = 'case_study_screen',
  DashboardHome = 'dashboard_home',
  Calendar = 'calendar',
}

export enum EnumNotificationSubcategory {
  ArticlePublished = 'article_published',
  CaseStudyPublished = 'case_study_published',
  NewProject = 'new_project',
  ApproveMilestone = 'approve_milestone',
  CompleteMilestone = 'complete_milestone',
  PaidMilestone = 'paid_milestone',
  Unflag = 'unflag',
  Flag = 'flag',
  ApproveContract = 'approve_contract',
  SubmittedContract = 'submitted_contract',
  BannerProjectReady = 'banner_project_ready',
  BannerProjectStarted = 'banner_project_started',
  BannerCreatorSubmittedContract = 'banner_creator_submitted_contract',
  BannerOtherSubmittedContract = 'banner_other_submitted_contract',
  BannerCreatorSubmittedAnnex = 'banner_creator_submitted_annex',
  BannerOtherSubmittedAnnex = 'banner_other_submitted_annex',
  BannerReviewedContract = 'banner_reviewed_contract',
  BannerOtherReviewedContract = 'banner_other_reviewed_contract',
  BannerReviewedAnnex = 'banner_reviewed_annex',
  BannerOtherReviewedAnnex = 'banner_other_reviewed_annex',
  BannerApproveContract = 'banner_approve_contract',
  BannerApproveAnnex = 'banner_approve_annex',
  BannerAnnexApplied = 'banner_annex_applied',
  BannerApproveMilestoneBuyer = 'banner_approve_milestone_buyer',
  BannerApproveMilestoneSeller = 'banner_approve_milestone_seller',
  BannerCompleteMilestoneBuyer = 'banner_complete_milestone_buyer',
  BannerCompleteMilestoneSeller = 'banner_complete_milestone_seller',
  BannerPaymentDue = 'banner_payment_due',
  BannerMilestonePaid = 'banner_milestone_paid',
  BannerRecurringMilestone = 'banner_recurring_milestone',
  BannerFlagCreator = 'banner_flag_creator',
  BannerFlagOther = 'banner_flag_other',
  BannerFlagResolved = 'banner_flag_resolved',
  BannerTimedProjectSubmitted = 'banner_timed_project_submitted',
  BannerTimedProjectRejected = 'banner_timed_project_rejected',
  BannerTimedProjectDraftSaved = 'banner_timed_project_draft_saved',
  BannerTimedProjectEditSubmitted = 'banner_timed_project_edit_submitted',
  BannerTimedProjectEditRejected = 'banner_timed_project_edit_rejected',
  BannerTimedProjectDeletionRequested = 'banner_timed_project_deletion_requested',
  BannerPitchSubmitted = 'banner_pitch_submitted',
  BannerPitchRejected = 'banner_pitch_rejected',
  BannerPitchEditSubmitted = 'banner_pitch_edit_submitted',
  BannerPitchEditRejected = 'banner_pitch_edit_rejected',
  BannerPitchApprovedBuyer = 'banner_pitch_approved_buyer',
  BannerPitchApprovedSeller = 'banner_pitch_approved_seller',
  BannerPitchRound2ApprovedSeller = 'banner_pitch_round_2_approved_seller',
  BannerPitchRound2ApprovedBuyer = 'banner_pitch_round_2_approved_buyer',
  BannerPitchRejectedManually = 'banner_pitch_rejected_manually',
  BannerPitchRejectedAutomatically = 'banner_pitch_rejected_automatically',
  BannerPitchHired = 'banner_pitch_hired',
  BannerPitchDeletionRequested = 'banner_pitch_deletion_requested',
  BannerPitchDeleted = 'banner_pitch_deleted',
  BannerCaseStudyApproved = 'banner_case_study_approved',
  BannerCaseStudyRejected = 'banner_case_study_rejected',
  BannerCaseStudyEditRejected = 'banner_case_study_edit_rejected',
  BannerCaseStudyReviewed = 'banner_case_study_reviewed',
  BannerBuyerProfileApproved = 'banner_buyer_profile_approved',
  BannerSellerProfileApproved = 'banner_seller_profile_approved',
  BannerSellerProfilePending = 'banner_seller_profile_pending',
  BannerSellerProfileRejected = 'banner_seller_profile_rejected',
  BannerEventInvitePending = 'banner_event_invite_pending',
  ReviewContract = 'review_contract',
  ContractReady = 'contract_ready',
  ApproveAnnex = 'approve_annex',
  SubmittedAnnex = 'submitted_annex',
  ReviewAnnex = 'review_annex',
  AnnexReady = 'annex_ready',
  TerminateContract = 'terminate_contract',
  CancelContract = 'cancel_contract',
  PaymentDue = 'payment_due',
  PaymentOverdue = 'payment_overdue',
  CreateTask = 'create_task',
  DeleteTask = 'delete_task',
  ApproveCaseStudy = 'approve_case_study',
  RejectCaseStudy = 'reject_case_study',
  ApproveCaseStudyEdit = 'approve_case_study_edit',
  RejectCaseStudyEdit = 'reject_case_study_edit',
  CaseStudyReviewLive = 'case_study_review_live',
  CaseStudyRequestReview = 'case_study_request_review',
  ApproveTimedProject = 'approve_timed_project',
  RejectTimedProject = 'reject_timed_project',
  NewTimedProject = 'new_timed_project',
  ApproveTimedProjectEditBuyer = 'approve_timed_project_edit_buyer',
  ApproveTimedProjectEditSeller = 'approve_timed_project_edit_seller',
  RejectTimedProjectEdit = 'reject_timed_project_edit',
  TimedProjectDeadlinePassed = 'timed_project_deadline_passed',
  DeleteTimedProjectBuyer = 'delete_timed_project_buyer',
  DeleteTimedProjectSeller = 'delete_timed_project_seller',
  DeleteTimedProjectCanceled = 'delete_timed_project_canceled',
  PitchSubmittedSeller = 'pitch_submitted_seller',
  PitchSubmittedBuyer = 'pitch_submitted_buyer',
  PitchRejected = 'pitch_rejected',
  PitchEditAcceptedSeller = 'pitch_edit_accepted_seller',
  PitchEditAcceptedBuyer = 'pitch_edit_accepted_buyer',
  PitchDeletedSeller = 'pitch_deleted_seller',
  PitchDeletedBuyer = 'pitch_deleted_buyer',
  PitchRound2Accepted = 'pitch_round_2_accepted',
  PitchRound1Rejected = 'pitch_round_1_rejected',
  PitchHired = 'pitch_hired',
  PitchRound2Rejected = 'pitch_round_2_rejected',
  PitchAutomaticallyRejected = 'pitch_automatically_rejected',
  DeletePitchCanceled = 'delete_pitch_canceled',
}

export const mapNotificationSubcategories = new Map([
  [EnumNotificationSubcategory.ArticlePublished, EnumNotificationCategory.Content],
  [EnumNotificationSubcategory.CaseStudyPublished, EnumNotificationCategory.Content],
  [EnumNotificationSubcategory.NewProject, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.ApproveMilestone, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.CompleteMilestone, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.PaidMilestone, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.Unflag, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.Flag, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.ApproveContract, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.SubmittedContract, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerProjectReady, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerProjectStarted, EnumNotificationCategory.E2EManagment],
  [
    EnumNotificationSubcategory.BannerCreatorSubmittedContract,
    EnumNotificationCategory.E2EManagment,
  ],
  [EnumNotificationSubcategory.BannerOtherSubmittedContract, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerCreatorSubmittedAnnex, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerOtherSubmittedAnnex, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerReviewedContract, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerOtherReviewedContract, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerReviewedAnnex, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerOtherReviewedAnnex, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerApproveContract, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerApproveAnnex, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerAnnexApplied, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerApproveMilestoneSeller, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerApproveMilestoneBuyer, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerCompleteMilestoneBuyer, EnumNotificationCategory.E2EManagment],
  [
    EnumNotificationSubcategory.BannerCompleteMilestoneSeller,
    EnumNotificationCategory.E2EManagment,
  ],
  [EnumNotificationSubcategory.BannerPaymentDue, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerMilestonePaid, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerRecurringMilestone, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerFlagOther, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerFlagCreator, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerFlagResolved, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.BannerTimedProjectSubmitted, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.BannerTimedProjectRejected, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.BannerTimedProjectDraftSaved, EnumNotificationCategory.Marketplace],
  [
    EnumNotificationSubcategory.BannerTimedProjectEditSubmitted,
    EnumNotificationCategory.Marketplace,
  ],
  [
    EnumNotificationSubcategory.BannerTimedProjectEditRejected,
    EnumNotificationCategory.Marketplace,
  ],
  [
    EnumNotificationSubcategory.BannerTimedProjectDeletionRequested,
    EnumNotificationCategory.Marketplace,
  ],
  [EnumNotificationSubcategory.BannerPitchSubmitted, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.BannerPitchRejected, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.BannerPitchEditRejected, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.BannerPitchEditSubmitted, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.BannerPitchApprovedBuyer, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.BannerPitchApprovedSeller, EnumNotificationCategory.Marketplace],
  [
    EnumNotificationSubcategory.BannerPitchRound2ApprovedSeller,
    EnumNotificationCategory.Marketplace,
  ],
  [
    EnumNotificationSubcategory.BannerPitchRound2ApprovedBuyer,
    EnumNotificationCategory.Marketplace,
  ],
  [EnumNotificationSubcategory.BannerPitchRejectedManually, EnumNotificationCategory.Marketplace],
  [
    EnumNotificationSubcategory.BannerPitchRejectedAutomatically,
    EnumNotificationCategory.Marketplace,
  ],
  [EnumNotificationSubcategory.BannerPitchHired, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.BannerPitchDeletionRequested, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.BannerPitchDeleted, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.BannerCaseStudyApproved, EnumNotificationCategory.Content],
  [EnumNotificationSubcategory.BannerCaseStudyRejected, EnumNotificationCategory.Content],
  [EnumNotificationSubcategory.BannerCaseStudyEditRejected, EnumNotificationCategory.Content],
  [EnumNotificationSubcategory.BannerCaseStudyReviewed, EnumNotificationCategory.Content],
  [
    EnumNotificationSubcategory.BannerSellerProfileApproved,
    EnumNotificationCategory.PostRegistration,
  ],
  [
    EnumNotificationSubcategory.BannerSellerProfilePending,
    EnumNotificationCategory.PostRegistration,
  ],
  [
    EnumNotificationSubcategory.BannerSellerProfileRejected,
    EnumNotificationCategory.PostRegistration,
  ],
  [
    EnumNotificationSubcategory.BannerBuyerProfileApproved,
    EnumNotificationCategory.PostRegistration,
  ],
  [EnumNotificationSubcategory.BannerEventInvitePending, EnumNotificationCategory.Calendar],
  [EnumNotificationSubcategory.ReviewContract, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.ContractReady, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.ApproveAnnex, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.SubmittedAnnex, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.ReviewAnnex, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.AnnexReady, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.TerminateContract, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.CancelContract, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.PaymentDue, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.PaymentOverdue, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.CreateTask, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.DeleteTask, EnumNotificationCategory.E2EManagment],
  [EnumNotificationSubcategory.ApproveCaseStudy, EnumNotificationCategory.Content],
  [EnumNotificationSubcategory.RejectCaseStudy, EnumNotificationCategory.Content],
  [EnumNotificationSubcategory.ApproveCaseStudyEdit, EnumNotificationCategory.Content],
  [EnumNotificationSubcategory.RejectCaseStudyEdit, EnumNotificationCategory.Content],
  [EnumNotificationSubcategory.CaseStudyReviewLive, EnumNotificationCategory.Content],
  [EnumNotificationSubcategory.CaseStudyRequestReview, EnumNotificationCategory.Content],
  [EnumNotificationSubcategory.ApproveTimedProject, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.RejectTimedProject, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.NewTimedProject, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.ApproveTimedProjectEditBuyer, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.ApproveTimedProjectEditSeller, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.RejectTimedProjectEdit, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.TimedProjectDeadlinePassed, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.DeleteTimedProjectBuyer, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.DeleteTimedProjectSeller, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.DeleteTimedProjectCanceled, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.PitchSubmittedSeller, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.PitchSubmittedBuyer, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.PitchRejected, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.PitchEditAcceptedSeller, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.PitchEditAcceptedBuyer, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.PitchDeletedSeller, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.PitchDeletedBuyer, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.PitchRound2Accepted, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.PitchRound1Rejected, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.PitchHired, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.PitchRound2Rejected, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.PitchAutomaticallyRejected, EnumNotificationCategory.Marketplace],
  [EnumNotificationSubcategory.DeletePitchCanceled, EnumNotificationCategory.Marketplace],
]);

export enum EnumOrderByOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export enum EnumServiceProviderScope {
  Local = 'local',
  Global = 'global',
  Undefined = 'undefined',
}

export enum EnumTimedProjectStatus {
  Active = 'active',
  Closed = 'closed',
  Draft = 'draft',
  Pending = 'pending',
  Archived = 'archived',
  Canceled = 'canceled',
}

export enum EnumTimedProjectPitchType {
  Form = 'form',
  Video = 'video',
}

export enum EnumTimedProjectPitchStatus {
  Draft = 'draft',
  Pending = 'pending',
  FirstRound = 'first_round',
  SecondRound = 'second_round',
  FirstRoundRejected = 'first_round_rejected',
  SecondRoundRejected = 'second_round_rejected',
  Chosen = 'chosen',
  FirstRoundWithdrawn = 'first_round_withdrawn',
  SecondRoundWithdrawn = 'second_round_withdrawn',
  Hired = 'hired',
  Archived = 'archived',
  Canceled = 'canceled',
}

export enum EnumTimedProjectPitchRejectFeedbackScope {
  Overall = 'overall',
  Knowledge = 'knowledge',
  Strategy = 'strategy',
  Budget = 'budget',
}

export enum EnumCaseStudyStatus {
  Draft = 'draft',
  Pending = 'pending',
  Published = 'published',
  Archived = 'archived',
  UnderReview = 'under_review',
  Verified = 'verified',
}

export enum EnumContactRequestType {
  Information = 'information',
  FeatureRequest = 'feature-request',
  Problem = 'problem',
  JoinRequest = 'join-request',
  Other = 'other',
}

export const mapContactRequestType = new Map([
  [EnumContactRequestType.Information, 'Information'],
  [EnumContactRequestType.FeatureRequest, 'Feature Request'],
  [EnumContactRequestType.Problem, 'Problem'],
  [EnumContactRequestType.JoinRequest, 'Join Request'],
  [EnumContactRequestType.Other, 'Other'],
]);

export enum ChatChannelType {
  Public = 'public',
  Direct = 'direct',
}

export enum FooterType {
  SellerArchive = 'seller_archive',
  CaseStudyArchive = 'case_study_archive',
}

export enum EnumSettingsType {
  BitrixAssignedBy = 'bitrix_assigned_by',
  SponaMediaContactRecipients = 'spona_media_contact_recipients',
  ContactUsRecipients = 'contact_us_recipients',
  CSReviewRequestBcc = 'cs_review_request_bcc',
  FinancingRequestRecipients = 'financing_request_recipients',
  SpContactUsRecipients = 'sp_contact_us_recipients',
}

export enum EnumBlogStatus {
  Draft = 'draft',
  Published = 'published',
}
export const mapBlogStatus = new Map([
  [EnumBlogStatus.Published, 'enums.blogStatus.published'],
  [EnumBlogStatus.Draft, 'enums.blogStatus.draft'],
]);

export enum EnumEmailLogType {
  Verification = 'email_verification',
  PasswordReset = 'password_reset',
  NewUserRegistred = 'new_user_registred',
  ConfirmAccount = 'confirm_account',
  CaseStudyReviewRequest = 'case_study_review_request',
}

export enum EnumBlogFeaturedPosition {
  One = 'one',
  Two = 'two',
  Three = 'three',
}

export enum EnumProjectRequestStatus {
  Requested = 'requested',
  ProjectCreated = 'project_created',
  Closed = 'closed',
  Deleted = 'deleted',
}

export const mapProjectRequestStatus = new Map([
  [EnumProjectRequestStatus.Requested, 'enums.projectRequestStatus.requested'],
  [EnumProjectRequestStatus.ProjectCreated, 'enums.projectRequestStatus.projectCreated'],
  [EnumProjectRequestStatus.Closed, 'enums.projectRequestStatus.closed'],
  [EnumProjectRequestStatus.Deleted, 'enums.projectRequestStatus.deleted'],
]);

export enum EnumPriceLookup {
  BasicMonthly = 'basic_monthly',
  BasicYearly = 'basic_yearly',
  StandardMonthly = 'standard_monthly',
  StandardYearly = 'standard_yearly',
  PremiumMonthly = 'premium_monthly',
  PremiumYearly = 'premium_yearly',
}

export enum EnumLinkedInFlow {
  SignIn = 'sign_in',
  SignUp = 'sign_up',
  CSReview = 'cs_review',
}

export enum EnumContractType {
  Default = 'default',
  Type2 = 'type_2',
}

export const mapContractType = new Map([
  [EnumContractType.Default, 'Default'],
  [EnumContractType.Type2, 'Type 2'],
]);
